const uz = {
	"datalogger": {
		"cancel": "Бекор қилиш",
		"resetData": "Маълумотларни ташлаш",
		"device_upgrade": "Қурилма прошивкасини янгилаш",
		"batchAddScq": "Маълумотлар регистраторининг оммавий қўшилиши",
		"updatefail": "Янгилаш хатоси, қурилма тармоқда эмас.",
		"Normal1": "Онлайн ҳолат",
		"deleteSuc": "Муваффақиятли олиб ташланди!",
		"county": "Туман",
		"Instruction": "Кўрсатма:",
		"select_file": "Илтимос, дастурий таъминотни танланг",
		"rebootDataloggerSuc": "Маълумотлар регистратори муваффақиятли қайта ўчиб ёнди",
		"confirm_deldte": "Маълумотлар йиғувчисини ўчириб ташлаганингиздан сўнг, сиз маълумотлар журнали билан боғлиқ барча маълумотларни бошқариш ҳуқуқига эга эмассиз",
		"buyProfitNew": "Электр энергиясини сотиб олиш нархи",
		"datalogger_debug": "Маълумотлар регистраторининг откладкаси",
		"province": "Қишлоқ/ вилоят",
		"clear_data": "Маълумотларни тозалаш",
		"Flowcard_status": "flow card ҳолати",
		"reAdd": "Қайта қўшиш",
		"connectionInfo": "Уланиш ҳақида маълумот",
		"location_info": "Манзил ҳақида маълумот",
		"editDatalogger": "Маълумотлар регистраторини модификациялаш",
		"Status": "Ҳолати",
		"Ple_Alias": "Илтимос, маълумотлар регистраторининг номини киритинг",
		"unbindResults": "Натижаларни ташлаш",
		"editResults": "Натижаларни ўзгартириш",
		"upgrade": "Янгилаш",
		"edit": "Таҳрирлаш",
		"Offline": "Тармоқда эмас",
		"Online": "Онлайн",
		"timeZone": "Вақт зонаси",
		"unbindDataloggerName": "Маълумотлар регистраторини ечиб ташлаш",
		"Communication_balance": "Алоқа баланси",
		"add_suc": "Муваффақиятли қўшилди",
		"sellProfit": "Электр энергиясини сотиш нархи:",
		"nominalPower": "Номинал қувват",
		"Datalogger_List": "Маълумот регистраторлар рўйхати",
		"installer": "Ўрнатувчи",
		"delResults": "Натижаларни ечиб ташлаш",
		"reset": "Қайта юклаш",
		"Datalogger_type": "Маълумотлар регистратори тури",
		"addResults": "Натижаларни қўшиш",
		"resetTitle": "Илтимос, YES ни киритинг маълумотлар регистраторини тиклашни хоҳлаётганингизни тасдиқлаш учун.",
		"upDatalogger": "Маълумотлар регистраторини янгилаш",
		"datalogger_pn": "Маълумотлар регистраторининг рақами:",
		"continueAdding": "Қўшишни давом эттириш",
		"resetCode": "Тасдиқлаш учун YES ни киритинг",
		"city": "Шаҳар",
		"latitude": "Кенглиги",
		"notActive": "Фаол бўлмаган",
		"Upload": "Юклаб олиш",
		"prompt_message": "Тезкор ҳабар",
		"usr_belong": "Фойдаланувчи",
		"unitProfit": "Ишлатилган электр энергия нархи:",
		"locationTip": "Фойдали маслаҳат: агар жойлашишни аниқлаш нотўғри бўлса ёки жойлашишни аниқлаш бажарилмаса, уни қўлда киритишингиз мумкин.",
		"basicInfo": "Шахсий маълумот",
		"Firmware_Version": "прошивка версияси",
		"upSuccessDatalogger": "Маълумотлар регистратори муваффақиятли янгиланди",
		"unbindDataloggerExplain": "Бу функция ишлаб чиқарувчига жўнатишдан олдин текширилгандан сўнг тест ҳисоб ёзивини (эгасини) маълумотлар регистраторидан узишни осонлаштириш учун ишлатилади. Илтимос, ушбу функциядан эҳтиёткорлик билан фойдаланинг. Операция тугагандан сўнг, мижоз маълумотлар регистраторини қайта улаши керак.",
		"resetDataloggerExplain": "Ушбу функция ишлаб чиқарувчиларга қурилмадаги маълумотларни булутдан тозаланишни осонлаштириш синов тариқасида ишлатилади.",
		"resetResults": "Натижаларни тиклаш",
		"currency": "Даромад валютаси:",
		"copy": "Муваффақиятли нусхалаш",
		"datalogger_name": "Маълумотлар регистраторининг номи:",
		"Datalogger_model": "Модели",
		"debug_suc": "Муваффақиятли откладлаш",
		"cp10": "Илтимос, лойиҳанинг номини киритинг",
		"address": "Маълумотлар регистраторининг манзили",
		"cp2": "Илтимос, вақт зонасини танланг",
		"cp1": "Ўрнатиш санасини танланг",
		"cp4": "Илтимос, валютани танланг",
		"more": "Кўпрок",
		"cp3": "Илтимос, номинал қувватни киритинг",
		"cp6": "Илтимос, лойиҳани танланг",
		"cp5": "Илтимос, қурилма номини киритинг",
		"finishAdding": "Қўшишни тугатиш",
		"cp7": "Kenglik va uzunlikni tanlang",
		"lonRange": "Uzunlik −180 dan 180 gacha bo'lgan sonlar oralig'ida bo'lishi kerak",
		"latRange": "Kenglik −90 dan 90 gacha bo'lgan sonlar oralig'ida bo'lishi kerak",
		"upFailDatalogger": "Маълумотлар регистратори янгиланишида хатолик",
		"Normal": "Меъёрда",
		"cp9": "Joriy manzilni kiriting",
		"resetSuc": "Ташлаб олиш якунланди",
		"confirm": "Тасдиқлаш",
		"modify_datalog": "Маълумотлар журналидаги ахборотни ўзгартириш",
		"activeStatus": "Фаол ҳолат",
		"com_method": "Алоқа усули",
		"Debugfail": "Откладкада хатолик, маълумотлар регистратори ўчирилган!",
		"sellProfitNew": "Электр энергиясини сотиш нархи:",
		"uploadSuccess": "Юклаб олиш муваффақиятли ўтди",
		"country": "Мамлакат",
		"location_info1": "Географик маълумотлар",
		"buyProfit": "Электр энергиясини сотиб олиш нархи:",
		"resetDataloggerName": "Маълумотлар регистраторини ташлаш",
		"Datalogger_Status": "Маълумотлар регистратори холати",
		"editDataloggerName": "Маълумотлар регистраторини таҳрирлаш",
		"modifySuc": "Муваффақиятли ўзгартирилди",
		"Ple_PN": "Илтимос, маълумотлар регистраторининг PN рақамини киритинг",
		"devaddrfail": "Алоқа учун манзили Майдон бўш бўлиши керек эмас",
		"Allstate": "Барча ҳолатлар",
		"longi_lati": "Узунлик ва кенглиги",
		"create": "Яратиш",
		"finish": "Якунлаш",
		"install_date": "Ўрнатиш санаси",
		"such_as": "Буйруқни киритинг, масалан: AA BB CC DD EE FF",
		"signal": "Сигнал",
		"longitude": "Узунлик",
		"unbindSuc": "Муваффақиятли ечилди",
		"editSuc": "Маълумотлар регистратори муваффақиятли ўзгартириш",
		"add": "Қурилма яратиш",
		"Offline1": "Офлайн ҳолат",
		"enterPosition": "Маълумотлар регистраторининг кириш манзили",
		"upBatchDataloggerTip": "Эслатма: оммавий янгиланиш бир хил маълумотлар регистратори прошивкаси учун бир нечта маълумотлар регистраторлари учун мўлжалланган.",
		"unbindTitle": "Илтимос, YES ни киритинг маълумотлар регистраторини терминалнинг жорий эгасига боғлашни бекор қилмоқчи эканлигингизни тасдиқлаш учун.",
		"update_suc": "Муваффақиятли янгиланди",
		"flowCard": "Хаққаний карта топилмади",
		"Active": "Фаол",
		"unbind": "Ечиб ташлаш",
		"return_content": "Таркибни қайтариш:",
		"district": "Маъмурий ҳудуд",
		"rebootDataloggerName": "Маълумотлар регистраторини қайта ёқинг",
		"send": "Юбориш",
		"Datalogger_PN": "PN қурилмалари",
		"generateProfitNew": "Электр энергия ишлаб чиқариш нархи",
		"Datalogger_Name": "Маълумотлар регистраторининг номи",
		"file_fist": "Аввал прошивкани танланг",
		"income_info": "Даромад ҳақида маълумот",
		"timezone": "Вақт зонаси",
		"addedSuccessfully": "Муваффақиятли қўшилди",
		"unbindUsr": "Эгасини ечиш",
		"Operation": "Ишлаш",
		"GPRS_traffic": "GPRS трафиги",
		"delete": "Олиб ташлаш",
		"nowNoAdd": "Ҳозир қўшилмасин",
		"administrator": "Администратор",
		"dataloggerAddress": "Батафсил манзил",
		"load": "Юклаш",
		"addSuc": "Маълумотлар регистратори муваффақиятли қўшилди",
		"Datalogger_method": "Алоқа усули",
		"fixOnRebootDataloggerName1": "бу",
		"fileExceed": "Файл ҳажми жуда катта",
		"reboot": "Қайта ёқиш",
		"generateProfit": "Электр энергия ишлаб чиқариш нархи:",
		"noNegative": "Manfiy bo'lmagan sonni kiriting",
		"basic_info": "Шахсий маълумот",
		"debug": "Откладкаси",
		"fixOnRebootDataloggerName": "Маълумотлар регистраторини қайта ишга туширишни тасдиқланг:",
		"select_firmware": "Илтимос, прошивка файлини танланг",
		"communication_address": "Алоқа манзили:",
		"check": "Tekshirish",
		"InstructionType": "Ko'rsatma formati",
		"endMarker": "Yakunlovchi belgi",
		"noMarker": "Yakunlovchi belgi yo'q",
		"noCheck": "Tekshirish yo'q",
		"InstructionIssue": "Ko'rsatma yuborish",
		"Insufficient": "Miqdor yetarli emas",
		"add_datalogger": "Маълумотлар регистраторини қўшиш",
		"currentAddress": "Жорий манзил:",
		"deleteTitle": "Маълумотлар регистраторини ўчириш",
		"timezone1": "Вақт зонаси",
		"addScq": "Маълумотлар регистраторини қўшиш",
		"instruction_response": "Кўрсатмаларни юбориш, жавобни кутиш...",
		"error1": "Сиз фақат форматдаги файлларни юклашингиз мумкин .bin и .hex!",
		"dataloggerTipName": "Kollektor qo'shildi, odamlar qo'shildi",
				"batch_edit_datalogger": "Ma'lumot yig'uvchini ommaviy tahrirlash",
				"upload_column_tips": "Eslatma: A ustuni Ma'lumot yig'uvchi PN, B ustuni yuklash soni, C ustuni baud tezligi, D ustuni aloqa protokoli, E ustuni qurilma ishlab chiqaruvchi kodi, F ustuni protokol ishlab chiqaruvchi kodi, G ustuni yig'ish rejimi, H ustuni min aloqa manzili, I ustuni max aloqa manzili, sarlavha kerak emas, quyidagi rasmga qarang",
				"upload_csv_tips": "Eslatma: Fayl formati csv bo'lishi kerak, mazmun uchun quyidagi rasmga qarang",
				"click_enlarge": "Batafsil ma'lumot uchun kattalashtirish",
						"collector_expire_time": "Kollektor muddati tugash vaqti",
						"collection_cycle": "Yig'ish sikli",
								"ascii_display": "ASCII ko'rsatish:"
	},
	"constant": {
		"gmt_neg_5": "(GMT-05: 00) Шарқий вақт (АҚШ ва Канада), Индиана (Шарқ), Богота, Лима, Кито",
		"gmt_neg_4": "(GMT-04: 00) Атлантик вақт (Канада), Куяба, Джорджтаун, Ла-Пас, Манаус, Сан-Хуан, Сантьяго, Асунсьон",
		"gmt_neg_7": "(GMT-07: 00) Чиуауа, Ла-Пас, Масатлан (эски), Тоғли вақт (АҚШ ва Канада), Аризона",
		"gmt_neg_6": "(GMT-06: 00) Марказий вақт (АҚШ ва Канада), Гвадалахара, Мехико, Монтеррей (эски)",
		"gmt_neg_1": "(GMT-01:00) Зангор Мыс ороллари, Азор ороллари",
		"gmt_neg_3": "(GMT-03: 00) Бразилиа, Буэнос-Айрес, Гренландия, Кайенна, Форталеза, Монтевидео",
		"gmt_neg_2": "(GMT-02:00) Ўртаатлантик координирлашган бутун жахон вақти-02",
		"gmt_11": "(GMT +11:00) Магадан, Соломонов оролари, Янги Каледония",
		"gmt_55": "(Гринвич бўйича вақт+05:30) Нью-Дели",
		"gmt_10": "(GMT +10:00) Брисбен, Владивосток, Гуам, Порт-Морсби, Хобарт, Канберра, Мельбурн, Сидней",
		"gmt_13": "(Гринвич вақти билан +13:00) Нукуалофа",
		"gmt_12": "(GMT +12:00) Окленд, Веллингтон, Петропавловск-Камчатка-Эски, Фиджи, Координирлашган бутун жахон вақти +12",
		"gmt_neg_9": "(Гринвич вақти-09:00) Аляска",
		"gmt_neg_8": "(GMT-08: 00) Тинчокеан вақти (АҚШ ва Канада), Пастки Калифорния",
		"gmt0": "(GMT +00:00) Координирлашган бутун жахон вақти, Ўртача вақт Гринвич, Дублин, Эдинбург, Лондон, Лиссабон, Касабланка, Монровия, Рейкьявик бўйича",
		"gmt_9": "(GMT +09:00) Осака, Саппоро, Токио, Сеул, Якутск",
		"gangbi": "гонконг доллари (гонконг доллари)",
		"gmt_7": "(GMT +07:00) Красноярск, Бангкок, Ханой, Джакарта",
		"gmt_8": "(GMT +08:00) Пекин, Чунцин, Гонконг, Урумчи, Куала-Лумпур, Сингапур, Перт, Тайбэй, Улан-Батор, Иркутск",
		"gmt_5": "(GMT +05:00) Тошкент, Екатеринбург, Исломобад, Карачи",
		"gmt_6": "(GMT +06:00) Олмата,Новосибирск,Остана,Дакка,Новосибирск",
		"gmt_65": "(GMT +06:30) Myanma",
		"gmt_neg_11": "(GMT-11:00) Самоа, Бутун жахон координирлашган вақт-11",
		"gmt_3": "(GMT +03:00) Боғдод, Қувайт, Эр-Рияд, Москва, кўч. Санкт-Петербург, Волгоград, Найроби",
		"ruidian": "швед кронаси (кр)",
		"gmt_neg_12": "(GMT-12:00) Ғарбда Ҳалқаро сана ўзгариш чизиғи",
		"gmt_4": "(GMT +04:00) Абу-Даби, Маскат, Ереван, Баку, Тбилиси, стандарт вақт Кавказа, Порт-Луи",
		"gmt_1": "(GMT +01:00) Амстердам, Берлин, Берн, Рим, Стокгольм, Вена, Белград, Братислава, Будапешт, Марказий-Ғарбий Африка, Виндхук",
		"baxi": "Хаққоний ($)",
		"gmt_2": "(GMT +02:00) Амман, Бейрут, Дамаск, Хараре, Претория, Хельсинки, Киев, Рига, София, Таллинн, Вильнюс, Каир, Минск, Афина",
		"renminbi": "Юанлар(￥)",
		"lubi": "РС(₹)",
		"gmt_neg_10": "(Гринвич вақти-10:00) Гавайа",
		"Rand": "Рубллар (RUB)",
		"moxige": "Мексика песоси(Mex$)",
		"yingbang": "фунт стерлинг (£)",
		"Pakistani": "ПКР (рупий)",
		"aoyuan": "Австралия доллари ($A)",
		"meiyuan": "АҚШ доллари ($)",
		"ouyuan": "ЕВРО(€)"
	},
	"cloudsUpgarde": {
		"cloudsFirmwareList": "Булутли Янгиланиш Рўйхати",
		"cloudsFirmware": "Булутли Дастурий Таъминотни Янгилаш"
	},
	"role": {
		"all": "Барчаси",
		"viewer": "Электр станцияси кузатувчиси",
		"plantOwnerNew": "Оддий фойдаланувчи",
		"plantOwner": "Станция эгаси",
		"distributor": "Дистрибъютор",
		"group": "Гуруҳ ҳисоб қайди",
		"manufacturer": "Ишлаб чиқарувчингинг ҳисоб қайди"
	},
	"CollectorCountByOMSOrder": {
		"23": "Ишлаб чиқарувчининг коди яроқсиз. Илтимос, администраторга мурожаат қилинг",
		"12": "Тартибда маълумотлар йиғувчининг ҳақиқий PN рақами йўқ, илтимос, буюртма рақамини тасдиқланг",
		"1": "Операция муваффақиятсиз тугади",
		"772": "Буюртма боғланган. Илтимос, буюртмадаги маълумотлар регистратори бошқа аккаунт билан боғланмаганлигини тасдиқланг",
		"259": "Ушбу буюртма учун яроқсиз маълумотлар регистратори мавжуд. Илтимос, администраторга мурожаат қилинг",
		"7": "Платформадаги носозлик",
		"8": "Рад этилди, администраторга мурожаат қилинг",
		"261": "Белгиланган дистрибютор топилмади, илтимос администраторга мурожаат қилинг"
	},
	"project": {
		"energyCurrent": "Жорий қувват",
		"tipCard": "Харита",
		"energyMonth": "Ой энергияси",
		"upload": "Юклаб олиш",
		"createResults": "Натижаларни яратиш",
		"back": "Орқага қайтиш",
		"project": "Лойиҳа",
		"createProject": "Лойиҳа яратиш",
		"deviceSn": "Қурилманинг серия рақами",
		"createSuc": "Яратиш муваффақиятли",
		"modifySuc": "Муваффақият",
		"delSuc": "Муваффақиятли олиб ташланди!",
		"upgradeSuc": "Муваффақиятли янгиланди",
		"tipList": "Рўйхат",
		"moveSelect": "Танланганни кўчириш",
		"limit": "Расм ҳажми 1М дан ошмаган",
		"placeholder": "Қурилма номи/SN/PN қидирилмоқда",
		"defaultProject": "Умолчаниядаги лойиҳа",
		"energyDate": "Энергиянинг санаси",
		"editSuc": "Муваффақиятни Таҳрирлаш",
		"editProject": "Лойиҳани ўзгартириш",
		"move": "Силжитиш",
		"energyTotal": "Умумий энергия",
		"tipSearchPN": "Маълумотлар қайдномаси",
		"editResults": "Натижаларни ўзгартириш",
		"projectRemark": "Лойиҳа буйича танбех",
		"manageProject": "Лойиҳа бошқаруви",
		"upgradeResults": "Натижа",
		"energyYear": "Йил энергияси",
		"delResults": "Натижаларни ечиб ташлаш",
		"delProject": "Лойиҳани ўчириш",
		"tipSearchSN": "Қурилма орқали",
		"projectName": "Лойиҳа номи",
		"choice": "Танлаш",
		"projectId": "Лойиҳа идентификатори",
		"moveTo": "..га ўтиш"
	},
	"Upload": {
		"Upload": "Юклаб олиш"
	},
	"login": {
		"code": "Жумбоқни якунлаш учун пастки слайдерни суринг.",
		"forgotUser": "Аккаунтимни унутдим",
		"scanning": "Сканерлаш",
		"loginSuc": "Кириш муваффақиятли амалга оширилди",
		"pv123": "PV123 ESS",
		"YZcode": "Илтимос, текшириш кодини киритинг",
		"login": "Tизимга кириш",
		"scan_download": "иловани юклаб олиш",
		"YHLogin": "Фойдаланувчи логини",
		"scan_login": "Сканерлаш коди орқали кириш",
		"usr": "Фойдаланувчи номи",
		"SmartESS": "SmartESS",
		"forgotPwd": "Паролни унутдингизми?",
		"app_download": "иловани юклаб олиш",
		"invitationLogin": "Exp-код билан кириш",
		"pwdformat": "Паролнинг нотўғри формати (6<=паролнинг рақамлари <=32)",
		"usrformat": "Ҳисоб қайдининг нотўғри формати (2<=ҳисоб қайдининг рақамлари<=32)",
		"Pleaseconfirm_login": "Илтимос, киришни тасдиқланг",
		"remember_pwd": "Мени эслаб қолиш",
		"YZcode_format": "тасдиқлаш кодининг нотўғри формати. Илтимос, рақамни киритинг",
		"invitation": "Exp-код",
		"no_invitation": "Exp-коди ҳали йўқми? Илтимос, биз билан боғланинг!",
		"signup": "Рўйхатдан ўтиш",
		"linkman": "Энергон",
		"sample_station": "Демо",
		"X_Tech": "X-Tech",
		"success": "Муваффақият",
		"no_account_yet": "Ҳисоб қайдингиз йўқми?",
		"Scancode_login": "Сканерлаш коди орқали кириш",
		"pwd": "Парол",
		"open": "очиш",
		"Swipe_right": "Ўнгга ўтказинг",
		"no_validitycode": "Taklif kodi amal qilish muddatida emas",
		"auto_login": "Автокирish",
	},
	"customize": {
		"orange": "Оранж ранг",
		"green": "Зангор",
		"classic": "Пушти",
		"blue": "Кўк",
		"purple": "Бинафша",
		"switchSkin": "Скинни алмаштириш"
	},
	"password": {
		"PLConfig_newpassword": "Илтимос, янги паролни тасдиқланг",
		"Current_password": "Эски пароль:",
		"User_name": "Фойдаланувчи номи:",
		"PLNew_password": "Илтимос, янги паролни киритинг",
		"New_password": "Янги пароль:",
		"Save": "Сақлаш",
		"PLCurrent_password": "Илтимос, эски паролни киритинг",
		"editPwdSuc": "Парол янгиланди",
		"Config_newpassword": "Янги пароль:",
		"loginAgain": "Парол муваффақиятли ўзгартирилди, илтимос, қайта киринг",
		"Password": "Асосий маълумот"
	},
	"recharge": {
		"cancel": "Бекор қилиш",
		"early_warning": "flow card картасининг амал қилиш муддати ҳақида огоҳлантириш",
		"orderno": "Буюртма рақами",
		"Recharge1": "Қайта қувватлаш созламаси",
		"rechargeStatus": "Қайта зарядлаш ҳолати",
		"openWx": "Илтимос, WeChat мобил телефонини очинг",
		"rechMoney": "Тўлдириш",
		"Recharge": "Қайта зарядлаш",
		"Dead_Time": "Тугаш вақти",
		"not_for_the_time_being": "Бекор қилиш",
		"rechDiscount": "Чегирма",
		"Search": "Қидириш",
		"warning": "Огоҳлантириш",
		"rechScan": "Тўловни якунлаш учун мобил WeChat ни очинг",
		"rechTip": "Iliq eslatma: 1. Xuddi shu buyurtma uchun siz faqat bir xil turdagi kartani (masalan, 4G mahalliy), bir xil yuk ko'tarish qobiliyatiga va bir xil qashshoqlikdan xalos bo'lish platformasi holatiga ega qurilmalarni tanlashingiz mumkin (standart displey yuklash sig'imi bo'lgan paketdir 1 va qashshoqlikni bartaraf etish platformasiga ulanmagan);",
		"Traffic_status": "Ҳолати",
		"Status": "flow card ҳолати",
		"DataloggerPN": "PN",
		"Recharge_money": "Балансни тўлдириш",
		"Overdue": "Муддати ўтган",
		"Datalogger_List": "Маълумот регистраторлар рўйхати",
		"Recharged": "Тўлдириш муваффақиятли",
		"Rcharge_Month": "Тўлов ойи",
		"Datalogger_PN": "PN қурилмалари",
		"rechargeDevice": "Маълумотлар регистратори :",
		"rechargeSucInfo": "Сиз муваффақиятли тўловни амалга оширдингиз ва трафик 24 соат ичида келади.",
		"scan": "Сканерлаш ва айлантириш",
		"Paid": "Тўланган",
		"Time": "Вақт",
		"Unpaid": "Тўланмаган",
		"Operation": "Ишлаш",
		"Connecting_Devices": "Юклаш",
		"Recharge_reminder": "Тўлдириш ҳақида эслатма",
		"scanComplete": "Тўловни бажариш учун ўтқазинг",
		"unknown": "Номаълум",
		"rechargeChannel": "Канал :",
		"Signal": "Сигнал",
		"Plant": "Электростанция",
		"rechargeDiscount": "Чегирма :",
		"expired": "Муддати",
		"load": "Юклаш",
		"Recharge_List": "Тўлдириш рўйхати",
		"ccid": "CCID",
		"Order_Number": "Буюртма рақами",
		"Recharge_record": "Трафикни тўлдириш",
		"DataloggerName": "Тахаллус",
		"Recharging": "Қайта зарядлаш",
		"Recharge_Selected": "Қайта зарядлаш",
		"rechargeErr": "Илтимос, бир хил миқдордаги юкланиш билан маълумотлар регистраторини танланг",
		"rechargePrice": "Нархи :",
		"normal": "Меъёрда",
		"previous": "Орқага қайтиш",
		"CCID": "CCID",
		"CCID_time": "flow card нинг амал қилиш муддати",
		"serial_number": "Йўқ",
		"Activation_Time": "Фаоллаштириш вақти",
		"confirm": "Тасдиқлаш",
		"Recharge_status": "Қайта зарядлаш ҳолати",
		"Recharge_now": "Ҳисобни ҳозир тўлдириш",
		"Content_warning": "Ҳурматли фойдаланувчи! Сиз фойдаланаётган қурилманинг flow card картаси тез орада тугаши аниқланди. Агар у ўз вақтида тўлдирилмаса, flow card картаси оператор томонидан бекор қилинади ва ундан кейин фойдалана олмайсиз. Балансингизни ўз вақтида тўлдиринг.",
		"Recharge_fail": "Қайта зарядлашда хатолик",
		"rechargePackage": "Қадоқлаш :",
		"rechargeSuc": "Тўлов муваффақиятли ўтди",
		"pn": "PN қурилмалари",
		"Recharge_successful": "Тўлдириш муваффақиятли",
		'recharge_type': "turi",
		'Service_Area': "xizmat ko'rsatish zonasi",
		'Package_type': "Paket turi",
		"Tips": "ishora",
		"Confirm_recharge": "To'ldirishni tasdiqlang",
		"Cancel_recharge": "To'ldirishni bekor qilish",
		"Hint_language1": "Agar siz to'ldirish vaqtida muammolarga duch kelsangiz, sotuvdan keyingi xizmat ko'rsatish liniyasiga 0755—89993588 raqamiga murojaat qiling.",
		'domestic': 'maishiy',
		'abroad': 'xorijiy',
		'Recharge_tip': 'Zaryadlash eslatmasi',
		'Recharge_tip1': "To'plamni to'ldirish uchun faqat bir xil turdagi kartalarni qo'llab-quvvatlaydi",
		'Recharge_tip2': "Iltimos, masalan: bir xil yuklash sig'imi 1; bir xil karta turi 4G; to'plamni to'ldirish uchun materik Xitoy ma'lumotlar kartasi;",
		'Recharge_tip3': "WeChat-ni allaqachon o'rnatgan foydalanuvchilar uchun tavsiya etiladi",
		'Recharge_tip4': "Paypalda ro'yxatdan o'tgan foydalanuvchilar uchun tavsiya etiladi",
		'Recharge_tip5': 'WeChat Pay',
		'Recharge_tip6': "To'ldirishni qo'llab-quvvatlamaydigan karta mavjud,Iltimos, administratorga murojaat qiling",
		'area_domestic': 'Xitoy materik',
		'area_abroad': 'aynalmilallik',
				'remedy_title': 'Заряд буюртмасини тузатиш',
				'upload_tip': 'Дўстона эслатма: Юклаш файли формати .txt'
	},
	"auxiliary": {
		"chartSupplement": "Ҳақиқий Жадвал",
		"auxiliaryFunction": "Ёрдамчи функция",
		"realChart": "Очилгандан сўнг, график ҳақиқий маълумотларни кўрсатади."
	},
	"rate": {
		"cancel": "Бекор қилиш",
		"buy_Rates": "Қувватни сотиб олиш нархи:",
		"device_status": "Қурилманинг ҳолати",
		"generate_Rates": "Электр энергиясини ишлаб чиқариш нархи:",
		"edit": "Таҳрирлаш",
		"Income_currencys": "Даромад валютаси:",
		"sell_Rates": "Қувватни сотиш нархи:",
		"datalogger_pns": "Маълумотлар регистраторининг рақами:",
		"resetSuc": "Ташлаб олиш якунланди",
		"sell_Rate": "Қувватни сотиш нархи",
		"generate_Rate": "Электр энергиясини ишлаб чиқариш нархи",
		"modifySuc": "Муваффақиятли ўзгартирилди",
		"confirm": "Тасдиқлаш",
		"buy_Rate": "Қувватни сотиб олиш нархи",
		"rate": "Ставка",
		"rate_list": "Тарифлар рўйхати",
		"operating": "Ишлаш",
		"Income_currency": "Даромад валютаси",
		"datalogger_name": "Маълумотлар регистраторининг номи",
		"datalogger_pn": "Маълумот регистраторнинг рақами",
		"unbindSuc": "Муваффақиятли ечилди",
		"status": "Ҳолати"
	},
	"intro": {
		"step_operate_1": "Ускуна ҳақидаги маълумотларнинг аниқроқ жойлашуви",
		"step_operate_2": "Ускунани танлагандан сўнг, сиз қувват оқимлари диаграммасини, ускуна ҳақидаги маълумотларни, маълумотлар жадвалини, параметрлар таҳлилини, батафсил маълумотларни ва жиҳознинг авариявий сигналлари ҳақидаги маълумотларни тезда кўришингиз мумкин.",
		"step_device_10": "Сиз учун муҳим бўлган ускунани топиш учун нима қулай",
		"step_project_5": "янги, ўзгартириш, олиб ташлаш",
		"step_project_4": "Функциялар, жиҳозларни ўринлари бўйича бошқариш. Фойдаланувчилар лойиҳани ўзгартиришлари мумкин",
		"slider_quite": "Юклаб олишдан чиқиш",
		"step_project_3": "Лойиҳа бошқаруви",
		"step_project_2": "Яқинда қўшилганлари",
		"step_project_1": "Янги тизим таркибини бошқариш",
		"step_device_6": "Қурилмада бўлганингизда “Обуна бўлиш” тугмасини босишингиз мумкин.",
		"step_device_7": "Огоҳлантиришдан кейин",
		"step_device_8": "Ушбу лойиҳада ускуна ...... сифатида фойдаланиш мумкин",
		"slider_next": "Кейинги қадам",
		"step_device_9": "Юқориги",
		"new_guide": "Янги бошловчилар учун қўлланма",
		"gaa_msg": "Ташвиш ҳақида эслатма",
		"step_device_1": "Қизиқтирган қурилмани тез топишQiziqarli qurilmalarni tezda toping",
		"step_device_2": "Яқинда қўшилганлари",
		"step_device_3": "Ускунага эътибор қаратинг",
		"slider_enter": "Янги версияни киритинг",
		"step_device_4": "Функция,",
		"step_device_5": "Сичқончани йўналтиринг",
		"sys_msg": "Тизим хабарномаси",
		"step_mode_3": "Рўйхат ёки варақча",
		"step_mode_4": "Тақдимот усулини вазиятингизга қараб танлашингиз мумкин.",
		"step_mode_1": "Жиҳозлар рўйхатининг ўзингизга ёққан услубини танланг",
		"step_mode_2": "Қурилмалар рўйхатига кириш ҳуқуқини ..... орқали олиш мумкин",
		"slider_pre": "Олдинги қадам",
				"unbind_tips": "Қурилма эгасига боғланмаган, аввал эгасини боғланг",
		"device_code1": "Қурилма коди"
	},
	"alarm": {
		"Alarm_Msg": "Янги хабар",
		"Alarm_Event": "Хавотир ҳодиса",
		"Intro_Msg": "Янги бошловчилар учун қўлланма",
		"Alarm_Status": "Огоҳлантириш ҳолати",
		"alarmNum": "Хавотир ходисалар сони",
		"alrmDes": "Хавотир сигнал филтрини тавсифи",
		"deviceFilter": "Қурилма филтри",
		"tips": "Маслахатлар",
		"details": "Тафсилотлар",
		"alarmDetails": "Signal тафсилотлари",
		"alarmInfo": "Signal ҳолати",
		"alarmDevice": "Қурилма Ҳақида Маълумот",
		"Close": "Ёпиш",
		"Device_PN": "PN қурилмалари",
		"Battery": "Батарея",
		"Alarm_Type": "Ходиса тури",
		"warning": "Огоҳлантириш",
		"device_address": "Қурилма манзили",
		"Camera": "Камера",
		"deviceType": "Қурилма тури",
		"curSelected": "Ҳозир вақтда танланди",
		"Status": "Ҳолати",
		"all": "Барчаси",
		"untreated": "ишлов берилмаган",
		"alrmType": "Хавотир сигнал турини филтрлаш",
		"delete_alarm": "Ушбу хабарни ўчиришни хоҳлайсизми?",
		"Delete_selected": "Танланганни ўчириш",
		"Microinverter": "Микроинвертор",
		"faultTitle": "Охирги 7 кун ичида хатолар сони",
		"warningTitle": "Сўнгги 7 кун ичида хавотир ходисалар сони",
		"Prevent_arcing_island": "island режимини ҳимоя қилиш мосламаси",
		"device_Warning": "Хавотир сигнал ускунаси",
		"Occurrence_time": "Пайдо бўлиш вақти",
		"device_Error": "Ускуна хатоси",
		"Alarm_Message": "Сенинг",
		"Alarm_List": "Огоҳлантиришлар рўйхати",
		"alarmStatus": "Хавотир ҳодисаларнинг умумий сони",
		"combining_manifolds": "Коллекторларни бирлаштириш",
		"allAlarm": "Умумий",
		"Device_Name": "Қурилма номи",
		"Device_SN": "Қурилманинг серия рақами",
		"Today_Alarm": "Бугунги хавотрили ҳодисалар",
		"Alarm_Read": "Барча хавотирлик сигналлар хабарномаларини ўқиб чиқдингиз",
		"device_alias": "Қурилма тахаллуси",
		"Alarm_data": "Айни пайтда сўнгги янгиликлар йўқ",
		"ruleManage": "Хавотрлик сигналларни филтрлаш қоидаларини бошқариш",
		"device_Fault": "Ўзулиш хатоси",
		"deletes": "Олиб ташлаш",
		"User": "Фойдаланувчи",
		"Cancel": "Бекор қилиш",
		"timeSlot": "Вақт оралиғи",
		"faultNum": "Хатолар сони",
		"Confirm": "Тасдиқлаш",
		"ruleNew": "Янги қоида",
		"Alarm_Describe": "Хавотир сигналининг тавсифи",
		"Operation": "Ишлаш",
		"storage": "Энергияни йиғиш назоратчиси",
		"error": "Хатолик",
		"Alarm_Message1": "Қурилма пайдо бўлмоқда",
		"offline": "Тармоқда эмас",
		"Plant": "Электр станцияси",
		"clearHistory": "Тарихни тозалаш",
		"ruleName": "Қоида номи",
		"Charger": "Батарея зарядловчи",
		"Alarm_Code": "Хавотир сигналининг коди",
		"more": "Кўпрок",
		"Device_Type": "Қурилма тури",
		"endtime": "Тугаш вақти",
		"fault": "Хатолик",
		"monitor": "Env-монитор",
		"inverter": "Инвертор",
		"filterHistory": "Филтрлар тарихи",
		"processed": "Қайта ишланган",
		"_Data": "Маълумотлар",
		"smart_meters": "Ақлли ҳисоблагичлар",
		"deleted_successfully": "Хавторлик сигнал муваффақиятли ўчирилди",
		"view": "ko'rsatib",
		"back": "Orqaga",
		"exportArchive": "Arxivlangan signalni eksport qilish",
		"archiveRecord": "Arxiv",
		"archiveTip": "Ro'yxat barcha ishlov berilmagan signallarni va 7 kun ichidagi ishlov berilgan yozuvlarni o'z ichiga oladi"
	},
	"plantCode": {
		"successfulApplication": "Аризангиз мувафақиятли қабул қилинди, илтимос, телефонингиз ёки электрон почта манзилингизга эътибор беринг, биз сиз билан имкон қадар тезроқ боғланамиз",
		"goRegister": "Рўйхатдан ўтишга ўтинг",
		"haveDevice": "Агар қурилмангиз бўлса, рўйхатдан ўтгандан кейин фойдаланиш учун тизимга киринг",
		"code_is_required": "Exp-коди талаб қилинади",
		"useDemo": "Таклифнома коди ҳали келмадими？Таклифнома коди фақат намойиш учун мўлжалланган",
		"pleaseName": "Илтимос, исмингизни киритинг",
		"PleaseNumber": "Илтимос, ўз телефон рақамингизни киритинг",
		"codeApplication": "Exp-кодининг қўлланилиши",
		"pleaseCode": "Илтимос, таклифнома кодини киритинг",
		"PleaseEmail": "Илтимос, электрон почта манзилингизни киритинг",
		"PleaseCompanyName": "Илтимос, компания номини киритинг",
		"reasonNotEmpty": "Ариза бериш сабаби бўш бўлиши мумкин эмас",
		"applyNow": "Ҳозир қўллансин",
		"PleaseApplication": "Илтимос, мурожаатингиз сабабини тушунтириб беринг",
		"PleaseCompanyAddress": "Илтимос, компания манзилини киритинг"
	},
	"firmware": {
		"Firmware_limit_format": "Faqat .bin, .hex va .s19 fayl formatlariga ruxsat beriladi",
		"Firmware_upload_fail": "Yuklash muvaffaqiyatsiz, iltimos qaytadan urinib ko'ring!",
		"Firmware_upload_failTip": "Yuklash muvaffaqiyatsiz",
		"Firmware_limit1": "Siz maksimal",
		"Firmware_limit2": "ta fayl",
		"Firmware_limit3": "firmware",
		"Firmware_limitM": "Alohida firmware fayl hajmi quyidagidan oshmasligi kerak:",
		"cancel": "Бекор қилиш",
		"Select_file": "Файлни танланг",
		"Upload1": "Файлларни юклаш",
		"Size": "Ҳажми (КБ)",
		"Firmware_desrc": "Тавсиф",
		"upgrade_quit1": "Янгиланиш хато билан якунланди ва тўхтатилди!",
		"deleteSuc": "Муваффақиятли олиб ташланди!",
		"Upload": "Юклаб олиш",
		"del_firmware": "Прошивкани олиб ташлаш",
		"Upload_firmware": "Юклаб олиш",
		"Operation": "Ишлаш",
		"downloadFirmware": "Юклаш",
		"tips": "Маслахатлар",
		"deleteFirmware": "Олиб ташлаш",
		"Firmware_Version": "Версия",
		"Firmware_List": "Ўрнатилган дастур созламаси",
		"limit1": "Фақат xlsx форматидаги файларни юклаш мумкин",
		"limit2": "Маслаҳат: юкланган файлнинг А устуни маълумотлар регисторининг PN ва В устуни маълумотлар регисторининг тахаллусидир. Қуйида кўрсатилгандек сарлавҳа талаб қилинмайди.",
		"limit": "Фақат .bin/.hex, файллари, 8М дан ошмаган холда",
		"limit0": "Фақат .bin/.hex/.s19, файллари, 8М дан ошмаган холда",
		"FailedCancelUpgrade": "Янгиланишни бекор қилиб бўлмади",
		"Firmware_Lists": "Прошивкалар руйхати",
		"uploadTips": "Илтимос, прошивка файлини юклаб олинг",
		"limit3": "Муваффақиятли қўшилди",
		"Upload_Time": "Юклаш вақти",
		"Add_Firmware": "Прошивка қўшиш",
		"upgrading1": "Уланишда янгилаш, илтимос кутинг",
		"Firmware_Name": "Прошивка номи",
		"upgrading": "Янгилаш",
		"editFirmware": "Таҳрирлаш",
		"Firmware_description": "Прошивка тавсифи:",
		"confirm": "Тасдиқлаш",
		"upgrade_quit8": "Янгилаш истисноси",
		"upgrade_quit7": "Муваффақияциз",
		"noRecord": "Ёзув йўқ",
		"upgrade_quit6": "Янгиланиш бекор қилинди",
		"UploadTitle": "Илтимос, оммавий файлларни юклаб олинг",
		"enter_content": "Илтимос, таркибни киритинг",
		"upgrade_quit5": "Янгиланишда эмас",
		"upgrade_quit4": "Янгиланиш қўлда бекор қилинди",
		"upgrade_quit3": "Муваффақиятли янгиланди",
		"delete_firmware": "Прошивкани олиб ташламоқчимисиз?",
		"upgrade_quit2": "Янгилаш хатоси, кейинроқ қайта уриниб кўринг!",
		"updateCompleted": "янгиланиш тугалланди",
		"firmware_upgrade": "Прошивкани янгилаш",
		"CancelUpgradeSuc": "Янгиланишни бекор қилиш муваффақиятли ўтди",
		"error1": "Сиз фақат форматдаги файлларни юклашингиз мумкин .bin и .hex .s19!",
        "error2": " Please press LFU button",
		"CancelUpgradeSuc11": "Bekor qilish muvaffaqiyatli amalga oshirildi, iltimos, to'plamchi bulutga ulanishini kuting va keyin yangilang.",
		"upgrade_wait": "Yangilanish tayyorlanmoqda, iltimos, 1–2 daqiqa kuting",
		"upgrade_wait1": "Yangilanish tayyorgarligi tugallandi. Iltimos, maʼlumot yigʻuvchi qurilma onlayn boʻlgach, yangilanish vazifasini qaytadan boshlang",
		"colOffline": "Datalogger onlayn emas",
		"colUpgrading": "Allaqachon yangilanish jarayonida",
		"UpgradeStarting": "Yangilanish boshlanishida, iltimos, kutib turing...",
		"upgradeSq_fail": "Datalogger yangilanmadi, keyinroq qayta urinib ko'ring!",
	},
	"map": {
		"datalogger": "Маълумотлар регистраторининг номи:",
		"address": "Манзил:",
		"sn": "Қурилманинг серия рақами:"
	},
	"group": {
		"cancel": "Бекор қилиш",
		"Delete": "Олиб ташлаш",
		"note": "ЭСЛАТМА",
		"entername": "Илтимос, гуруҳ номини киритинг",
		"deletegroup": "Гуруҳни ўчириш",
		"deletesuc": "Гуруҳ муваффақиятли ўчирилди",
		"deleteConfirm": "Ушбу гуруҳни ўчиришни хоҳлайсизми?",
		"Operate": "Ишлаш",
		"Group_name": "Гуруҳ номи",
		"Create_groups": "Гуруҳлар яратиш",
		"editsuc": "Гуруҳни муваффақиятли таҳрирланди",
		"Group_name1": "Гуруҳ номи:",
		"confirm": "Тасдиқлаш",
		"userCount": "Фойдаланувчилар сони",
		"Groups_list": "Гуруҳлар рўйхати",
		"Edit_groups": "Гуруҳларни таҳрирлаш",
		"creatsuc": "Гуруҳ муваффақиятли яратилди",
		"finish": "Якунлаш",
		"note1": "ЭСЛАТМА:"
	},
	"controlDeviceErrCode": {
		"11": "Рухсат йўқ, администраторга билан боғланинг",
		"1": "Операция муваффақиятсиз тугади. Илтимос, қурилмангизни текширинг ва қайта уриниб кўринг!",
		"2": "Жавоб олиш муддати тугади, қайта уриниб кўринг!",
		"3": "Тизим хатолар билан ишламоқда. Илтимос, администраторга мурожаат қилинг",
		"6": "Формат хатоси, администраторга мурожаат қилинг",
		"8": "Рад этилди, администраторга мурожаат қилинг",
		"9": "Операция қўллаб-қувватланмайди, администраторга мурожаат қилинг",
		"263": "Маълумотлар регистратори ҳозирда ўчирилган. Илтимос, ускунани тармоққа улаганингиздан сўнг қайта уриниб кўринг!"
	},
	"control":{
		"setting": "Berish",
		"TouSetting": "Tizim Ishlash Rejimi",
		"touCharge": "Zaryad Prioriteti",
		"touPersonal": "Shaxsiy Ist'e'mol",
		"touComplete": "To'liq Tarmoqqa Ulash",
		"touClipping": "Cho'qqilarni Kesish va Vodiylarni To'ldirish",
		"touOffgrid": "Tarmoqsiz Ilova",
		"confirmModeSwitch": "Rejimni Almashtirishni Tasdiqlaysizmi?",
		"modeSwitch": "Rejimni Almashtirish",
		"startTime": "Boshlanish Vaqti",
		"endTime": "Tugash Vaqti",
		"paramValue": "Parametr Qiymatini Tanlang",
		"Monday": "Dushanba",
		"Tuesday": "Seshanba",
		"Wednesday": "Chorshanba",
		"Thursday": "Payshanba",
		"Friday": "Juma",
		"Saturday": "Shanba",
		"Sunday": "Yakshanba",
		"syncSetDay": "Har Kun Sinxron Berish",
		"time": "Vaqt Davri 1",
		"time1": "Vaqt Davri 2",
		"time2": "Vaqt Davri 3",
		"time3": "Vaqt Davri 4",
		"time4": "Vaqt Davri 5",
		"time5": "Vaqt Davri 6",
		"setFail": "Berish Muvaffaqiyatsiz Tugadi",
		"readFail": "O'qish Muvaffaqiyatsiz Tugadi",
		"charge": "Zaryad Qilish",
		"discharge": "Zaryadni Bo'shatish",
		"reading": "Muvaffaqiyatli O'qildi",
		"reading_loading": "O'qilmoqda...",
		"pvMode": "Tarmoqqa Ulash Rejimi",
		"screenshot": "Skrinshot"
	},
	"statistic": {
		"All": "Барчаси",
		"bc": "Ma'lumotlarni yuklab olish",
		"normal": "Меъёрда",
		"other": "Бошқаси",
		"totalRegion": "Бутун минтақа",
		"totalDevice": "Барча қурилмалар",
		"standby": "Кутиш режими",
		"regiontotal": "Умумий майдони",
		"sy": "Қурилма маълумотлари",
		"pv": "Қуёш панели маълумотлари",
		"active": "Фаол",
		"allDevice": "Барча қурилмалар",
		"fault": "Хатолик",
		"generalAccount": "Эга Фойдаланувчилар",
		"deviceStatus": "Қурилманинг ҳолати",
		"allAccount": "Барча фойдаланувчилар",
		"offline": "Тармоқда эмас",
		"regionPercent": "Минтақавий мутаносиблик",
		"bt": "Батарея маълумотлари",
		"inactive": "Фаол эмас",
		"Allstate": "Барча ҳолатлар",
		"adminAccount": "Дистрибъютер Фойдаланувчи",
		"warning": "Огоҳлантириш",
		"userActivity": "Фойдаланувчининг фаоллик даражаси",
		"dataUpdateTime": "Маълумотларни янгилаш вақти",
		"gd": "Тармоқ маълумотлари"
	},
	"settingalarm": {
		"Delete": "Олиб ташлаш",
		"Add": "Қўшиш",
		"cancel": "Бекор қилиш",
		"Warning": "Огоҳлантириш",
		"deletes": "Олиб ташлаш",
		"Email": "Электрон почта манзили",
		"Add_suc": "Электрон почтани муваффақиятли қўшиш",
		"suredelete": "Электрон почтадаги хабарномани ўчирасизми?",
		"Yes": "Ҳа",
		"Fault": "Хатолик",
		"Operation": "Ишлаш",
		"E_Mail": "Электрон почта манзили:",
		"delete": "Электрон почта муваффақиятли ўчириш!",
		"chosesstation": "Илтимос, электро станцияни танланг",
		"Receiving_Plant": "Қабул қилувчи электростанцияси",
		"Plant": "Электр станцияси",
		"Alarm_Type": "Хавфли сигнал тури:",
		"create": "Яратиш",
		"Monthly_Report": "Ойлик ҳисобот",
		"Add_Mailbox": "Почта қутисини қўшиш",
		"No": "Йўқ",
		"Yearly_Report": "Йиллик ҳисобот",
		"edit": "Таҳрирлаш",
		"addEmails": "Электрон почта қўшиш",
		"Error": "Хатолик",
		"list": "Йўқ",
		"Email_Setting": "Электрон почта созламаси",
		"Email_List": "Электрон почта манзиллари рўйхати",
		"Receiving_Report": "Ҳисобот олиш",
		"Alarm_Typetabel": "Ходиса тури",
		"Delete_Mailbox": "Почта қутисини ўчириш",
		"Daily_Report": "Кунлик ҳисобот"
	},
	"message": {
		"cancel": "Бекор қилиш",
		"pwd_is_required": "Парол бўш бўлиши мумкин эмас",
		"id_is_required": "Гуруҳлаш бўш бўлиши мумкин эмас",
		"email_info": "Илтимос, 64 та рақам ичида тўғри электрон почта манзилини киритинг",
		"delete_plant": "Электростанцияни олиб ташлаш",
		"Exporting_the_report": "Ҳисоботни экспорт қилиш",
		"length6_20": "Фақат 6-20 та ҳарф, рақамлар, пастки чизиқ киритилиши мумкин",
		"length6_32": "6 дан 32 гача рақамлар",
		"nodata": "Ёзувлар йўқ",
		"oldPass_wrong": "Эски парол нотўғри, уни яна киритинг",
		"invitation_is_required": "Exp-коди талаб қилинади",
		"length2_32": "2 дан 32 гача рақамлар",
		"pwdSame": "Эски ва янги пароллар мос келмайди",
		"pn_is_required": "PN бўш бўлиши мумкин эмас",
		"pwdAgain": "Паролни тасдиқланг",
		"search": "Қидириш",
		"pwdNotsame": "Иккита кириш паролининг номувофиқлиги",
		"length2_64": "2 дан 64 гача рақамлар",
		"uname_is_required": "Ааккаунт бўш бўлиши мумкин эмас",
		"Logging_off": "Бу ҳисоб қайди бекор қилинган ва тизимга кира олмайди",
		"modify_plant": "Электростанцияни ўзгартириш",
		"PN_info": "PN рақами 14 ёки 18 бит узунликда, шу жумладан камида битта бош ҳарф.",
		"confpwd_is_required": "Паролни тасдиқлаш майдони бўш бўлиши мумкин емас",
		"mobile_is_required": "Телефон рақами бўш бўлиши мумкин эмас",
		"email_is_required": "Электрон почта бўш бўлиши мумкин эмас",
		"country_is_required": "请选择国家或地区",
	},
	"menu": {
		"datalogger": "Маълумотлар қайдномаси",
		"Total_user": "Жами фойдаланувчилар:",
		"customize": "Маълумот алмашиш тезлиги созламаси",
		"setting": "Тизим созламалари",
		"password": "Асосий маълумот",
		"rate": "Тўлдиришни қайд этиш",
		"recharge": "Мобил қурилма созламаси",
		"record": "Трафикни тўлдириш",
		"alarm": "Хавотир",
		"firmwarenew": "Ўрнатилган дастур созламаси",
		"adaptiveFirmware": "Moslashuvchi Mikrodastur",
		"firmware": "Фойдаланувчи созламаси",
		"email": "Авариявий огоҳлантириш созламаси",
		"myDevice": "Менинг қурилмам",
		"overview": "Шарҳ",
		"functionalApplication": "Функционал илова",
		"mobile": "Электрон почта созламаси",
		"pay": "Қайта қувватлаш созламаси",
		"personal": "Параметр",
		"alarmSetting": "Паролни ўзгартириш",
		"home": "Бошига қайтиш",
		"browseAccount": "Суб-аккаунтни бошқариш",
		"cloudsUpgrade": "Булутли янгиланиш",
		"strategy": "Стратегияни тўғирлаш",
		"basic": "Шахсий маълумот",
		"device": "Қурилма",
		"account": "Ҳисоб қайди",

		"log": "Ma'lumotlar yig'uvchi jurnali",
		"actionLog": "Operatsiya jurnali",
		"Manufacturer": "Zavod boshqaruvi",
		"datalogger_list": "Ma'lumot yig'uvchilar ro'yxati",
		"manufacturer_account": "Ishlab chiqaruvchi hisobi",
		"manufacturer_code": "Ishlab chiqaruvchi kodi",
		"protocol_binding": "Ma'lumotlar jurnali protokoli ulanishi",
		"type_code": "Ma'lumotlar jurnali turi kodi",
		"protocol_change": "Ma'lumotlar jurnali protokolidagi o'zgarishla",
		"AIP_Interface": "API interfeysi interfeysi",
		"protocol_operation": "Protokol bilan ishlash vositalari",
		"recharge_management": "Zaryadni boshqarish",
		"device_management": "Qurilma boshqaruvi",
		"KEY_List": "KEY ro'yxati",
		"Protocol_instruction": "Protokol buyrug'ini boshqarish",
		"Raw_data": "Xom ma'lumotlarni tahlil qilish",
		"Recharge_remedy": "Zaryadlovchi vosita",
		"device_function": "Qurilmani boshqarish funktsiyasi",
		"Password_maintenance": "Boshqaruv elementi parolini saqlash",
	},
	"signup": {
		"too_simple": "Пароль жуда оддий, илтимос яна бир марта киритинг",
		"code": "6 хонали текшириш коди",
		"qiangdu": "Паролнинг ишончлилиги:",
		"di": "Заиф",
		"registered": "Рўйхатдан ўтиш",
		"login": "Tизимга кириш",
		"confirm_Pwdpl": "Паролни тасдиқланг",
		"mobile_pl": "Телефон рақами",
		"confirm_password": "Паролни тасдиқланг",
		"emailSignup": "Электрон почта манзилини рўйхатдан ўтказиш",
		"PN_pl": "PN",
		"zhong": "Ўртача",
		"email_form": "64 та белги орасида, паролни топиш учун аниқ киритинг.",
		"usr": "2-32 та белги (инглиз тилида, ҳарф, рақам, пастки чизиқ)",
		"emailformat": "Илтимос, тўғри почта қутисини киритинг",
		"email": "Электрон почта манзили",
		"pwdformat": "Парол форматидаги хатолик, 6 ~ 32 рақамлар (фақат рақамлар, ҳарфлар, пастки чизиқ)",
		"usrformat": "Ҳисоб қайдининг хатолиги, 2-32 рақамлар (фақат инглиз тили, ҳарфлар, рақамлар тагига чизилган)",
		"email_pl": "Электрон почта манзили",
		"pwd_pl": "Парол",
		"Byte_2": "Иштирокчилар",
		"pnformat": "PN формати хатолиги, 14 та ёки 18 та рақам (фақат рақамлар ва ҳарфлар)",
		"Byte_1": "Киритиб бўлинган",
		"phoneSignup": "Телефон орқали рўйхатдан ўтиш",
		"mobileformat1": "Илтимос, тўғри мобил телефон рақамини киритинг",
		"mobileformat": "Телефон рақамининг нотўғри формати (6- 32 рақамлар)",
		"qiang": "Кучли",
		"code_pl": "Текшириш коди",
		"confirm_pl": "Паролни тасдиқланг",
		"signup": "Рўйхатдан ўтиш",
		"phone": "Телефон",
		"success": "Муваффақиятли рўйхатдан ўтиш!",
		"usr_pl": "Фойдаланувчи номи",
		"phone_form": "32 та белги орасида, паролни топиш учун аниқ киритинг.",
		"Register_account": "Ҳисоб қайдини рўйхатдан ўтказиш",
		"existing_account": "Сизда аллақачон ҳисоб қайди борми?",
		"pwd": "Катта-кичиклигига қараб (рақам, ҳарф, пастки чизиқ) 6-32 та belgi",
		"pn": "14 та ёки 18 та белги (фақат рақамлар ва ҳарфлар)",
		"country_pl": "国家或地区",
	},
	"version": {
		"to_new": "Янги версия",
		"to_old": "Эски версия",
		"custom_theme": "Фойдаланувчи мавзуси",
		"default_theme": "Сукут бўйича мавзу",
		"default_node": "Сукут бўйича тугун"
	},
	"createPlant": {
		"fileExceed": "Файл ҳажми жуда катта",
		"Control_settings": "Аккумулятор созламаси",
		"basic_settings": "Асосий созлама",
		"Basic_setting": "Асосий созлама",
		"select_all": "Barchasini tanlash",
		"pv": "PV",
		"gd": "Tarmoq",
		"bt": "Batareya",
		"bc": "Yuk",
		"sy": "Tizim",
		"eg": "Generator",
		"hl": "UyYuki",
		"System_settings": "Тизим созламалари",
		"Grid_settings": "Тармоқ созламаси",
		"Solar_settings": "Қуёш тизими созламаси",
		"imageLimit": "Тасвирлар фақат: jpg, png форматида бўлиши ва 8Mб дан ошмаслиги керак",
		"Load_setting": "Созламани юклаб олиш",
		"Standard_setting": "Стандарт созламалар",
		"other_settings": "Бошқа созлама",
		"Advanced_setting": "Кенгайтирилган созламалар",
		"Battery_settings": "Батарея созламаси",
		"Battery_settingsTT": "Batareya umumiy sozlamalari",
		"Battery_settings1": "Batareya toʻplami 1",
		"Battery_settings2": "Batareya toʻplami 2",
		"Work_settings2": "Tizim ishlash holatini sozlash",
		"Machine_settings2": "Mashina tayyorlik funksiyasini yoqish",
		"Clear_settings2": "Xatoni tozalash",
		"uploadSuccess": "Юклаб олиш муваффақиятли ўтди"
	},
	"upgradeManagement": {
		"cancel": "Бекор қилиш",
		"eidt_success": "Муваффақиятни Таҳрирлаш",
		"delete_success": "Cенcел Муваффақияти",
		"edit_firmware": "Таҳрирлаш",
		"delete_success1": "Муваффақиятли олиб ташланди!",
		"download_firmware": "Юклаш",
		"upgrade_file_format1": "Фақат юклашингиз мумкин. бин/. ҳех формати",
		"upgrade_file_format2": "Файл 1 МБ дан ошмаслиги керак",
		"Upload": "Юклаб олиш",
		"Firmware_Version": "Версия",
		"firmwareName_empty": "Микродастур номи бўш бўлиши мумкин емас",
		"confirm": "Тасдиқлаш",
		"upgrade_file_format": "Фақат юклашингиз мумкин. бин/. ҳех формати 1мб дан ошмаслиги керак",
		"firmware_name": "Микродастур Номи",
		"Remarks": "Тавсиф",
		"please_upgrade": "Илтимос, юклаш файлини танланг",
		"download_firmware_prompt": "Ушбу дастурий таъминотни юклаб олишни хоҳлайсизми?",
		"upload_firmware": "Юклаб олиш",
		"create": "Яратиш",
		"please_input": "Илтимос, киритинг",
		"firmwareVersion_empty": "Версия рақами бўш бўлиши мумкин емас",
		"download_success": "Муваффақиятни юклаб олинг",
		"delete_desc": "Ўчирилгандан сўнг, уни тиклаш мумкин бўлмайди ва ушбу дастурий таъминот учун танланган янгиланиш стратегияси қурилмани янгилай олмайди",
		"upgrade_success": "Муваффақиятни юкланг",
		"download_exception": "Yuklab olish istisno, keyinroq qayta urinib ko‘ring",
		"upload_result": "Yuklash natijasi",
	},
	"401": {
		"goback": "Олдингисига қайтиш",
		"gohome": "Бошига қайтиш",
		"oops": "Вой!",
		"noAuth": "Сизнинг бу саҳифага кириш ҳуқуқингиз йўқ"
	},
	"errCode": {
		"271": "Модификация операцияси йўқ",
		"272": "Боғлашни такрорлаш",
		"273": "Бошқа ишлаб чиқарувчилар учун қўшишни қўллаб-қувватламайди",
		"352": "Прошивкани топа олмаяпман",
		"353": "Рол топилмади",
		"276": "Бошқа ишлаб чиқарувчилар билан мобил қурилмаларга эга бўлган электр станциялари эгаларини қўллаб-қувватламайди.",
		"512": "SMS аутентификация кодининг мос келмаслиги",
		"513": "Тасдиқлаш коди муддати тугади",
		"514": "Телефон/электрон почта рақамларининг мос келмаслиги",
		"515": "Телефон рақами/электрон почта боғланмаган",
		"516": "Исм мос келмайди",
		"517": "Тизимда бир хил фойдаланувчи ёки электр станцияси учун маълумотларни рўйхатга олиш рақами мавжуд",
		"518": "Фойдаланувчида бўйсунувчи фойдаланувчи ҳам мавжуд",
		"519": "аккаунтни такрорлаш",
		"10": "Аутентификация муваффақиясиз ўтилди, илтимос, қайтадан киринг",
		"11": "Қўллаб-қувватланмайдиган операциялар",
		"12": "Ёзув йўқ",
		"13": "Ташқарида",
		"14": "Такрорий операциялар",
		"15": "Ишлаб чиқарувчининг калити йўқ",
		"16": "Паролни текширишда хато",
		"17": "Парол форматидаги хато",
		"18": "Телефон рақам боғланган",
		"1792": "Маълумот йиғувчи дистрибюторга тегишли бўлиши керак",
		"19": "Телефон рақам форматида хато",
		"1031": "Фойдаланувчи ушбу администратор томонидан яратилмаган",
		"1030": "GPRS картаси нотўғри",
		"0": "Яхши, хатосиз",
		"1029": "Қўллаб-қувватланмайдиган қайта зарядлаш",
		"1": "Хатолик",
		"1028": "Рақамли маълумотлар регистраторининг такрорланадиган сони",
		"288": "Камерани топа олмаяпман",
		"2": "Бироздан сўнг",
		"1027": "Юқори фойдаланувчи дистрибютор ёки ускуналар ишлаб чиқарувчиси бўлиши керак",
		"520": "Қайтарилайдиган PN рақам",
		"3": "Тизим хатолар билан ишламоқда. Илтимос, администраторга мурожаат қилинг",
		"1026": "Фақат ускуналар ишлаб чиқарувчиларни қўллаб-қувватлаш",
		"521": "Қабул қилувчи фойдаланувчига тегишли эмас",
		"4": "Текшириб бўлмайдиган имзо",
		"1025": "Фақат дилерларни қўллаб-қувватлаш",
		"522": "Маълумотлар регистратор рақами мавжуд",
		"368": "Келишувни топиш имкони йуқ",
		"5": "Қиймат нотўғри кўрсатилган ва қоидаларга мувофиқ ишлатилмаяпти",
		"1024": "Браузер ҳисоби ёзуви эмас",
		"523": "Фақат электр станциялари эгаларини қўллаб-қувватлаш",
		"369": "Фойдаланувчи гуруҳлари топилмади",
		"6": "Параметр формати хатоси",
		"7": "Платформадаги носозлик",
		"525": "Тасдиқлаш коди юборилди. Кейинроқ қайта уриниб кўринг.",
		"528": "Bu rol foydalanuvchiga bog‘langan va uni o‘chirib bo‘lmaydi",
		"8": "Имтиёзсиз операция",
		"768": "Протоколда ихтиёрий майдонлар мавжуд эмас",
		"9": "Керакли параметрларнинг етишмаслиги",
		"20": "Ҳисоб ёзуви форматида хато",
		"21": "Ҳисоб ёзув форматида хато (2 <= ҳисоб ёзув рақамлари < 32)",
		"22": "Компания номи форматидаги хато",
		"23": "Ишлаб чиқарувчининг коди яроқсиз",
		"24": "аккаунтни такрорлаш",
		"25": "Аккаунт ўчирилган, администраторга билан боғланинг",
		"26": "Е-маил аллақачон боғлиқ, е-почта ўзгартириш ёки мажбурий бекор қилинг.",
		"27": "Аккаунт бекор қилинган. Илтимос, администраторга мурожаат қилинг",
		"1042": "Нотўғри CCID",
		"1041": "Калит нотўғри ёки топилмади",
		"370": "Бир гуруҳ электр станцияларини топиб бўлмади",
		"371": "GPRS трафикни тўлдириш пакети топилмади",
		"372": "Тўлдириш тартиби топилмади",
		"772": "Маълумотлар йиғувчиси боғланган",
		"256": "Ёзувлар йўқ",
		"257": "Ускуна топилмади",
		"258": "Ускунани топиш имкони йуқ",
		"259": "Нотўғри PN рақами, PN рақамининг тўғрилигини текширинг",
		"260": "Бирорта электр станциясини топиб бўлмайди",
		"261": "Фойдаланувчи топилмади",
		"262": "Ускуна ўчирилган",
		"384": "Тасдиқлаш коди хатоси",
		"263": "Маълумотлар регистратори ўчирилган",
		"385": "device_token топишни имкони бўлмади",
		"264": "Ускуналар учун сигналлар йўқ",
		"386": "Қурилма конфигурацияси ҳақида маълумот топилмади",
		"265": "Атроф-муҳит детектори топилмади",
		"387": "Маълумотлар регистраторининг турини топиб бўлмади"
	},
	"report": {
		"cancel": "Бекор қилиш",
		"select_date": "Илтимос, санани танланг",
		"Yearly_Report": "Йиллик ҳисобот",
		"Export_report": "Ҳисоботни экспорт қилиш",
		"Export_alarm": "Хавотирни экспорт қилиш",
		"Report_date": "Ҳисоблаш санаси:",
		"no_deAlarm": "Охирги ойда қурилманинг ҳеч қандай хавотирли сигнализацияси юз бермади",
		"Report_date1": "Эслатма. Саналар орлиғи 31 кундан ошмаслиги керак.",
		"Total_report": "Умумий ҳисобот",
		"Subscribe_report": "Ҳисоботга обуна бўлиш",
		"customize": "Созлаш",
		"all_reports": "Барчасини экспорт қилиш",
		"current": "Жорий",
		"download": "Юкланиш кутилмоқда, илтимос, кутинг",
		"Report_type": "Ҳисобот тури:",
		"Export": "Экспорт",
		"Daily_report": "Кунлик ҳисобот",
		"to": "Га",
		"Batch_export": "Тўпламли экспорт",
		"Monthly_report": "Ойлик ҳисобот",
		"End_date": "Тугаш санаси",
		"start_date": "Бошланиш санаси"
	},
	"404": {
		"notFound": "Саҳифа топилмади!"
	},
	"retrieve": {
		"Verification_code": "Текшириш коди",
		"passwordPhone": "Мобил телефон рақами боғланмаган",
		"Email": "Электрон почта манзили",
		"enter_code": "Илтимос, текшириш кодини киритинг",
		"re-register": "Қайта рўйхатдан ўтиш",
		"login": "Tизимга кириш",
		"Reset_successfully": "Ташлаш муваффақиятли амалга оширилди, илтимос паролингизни эслаб қолинг",
		"Retrieve_passwordEmail": "Паролни электрон почта орқали тиклаш",
		"bound_mobile": "Илтимос, боғланган мобил телефон рақамини киритинг",
		"Retrieve_password": "Паролни олиш",
		"passwordPhone1": "Мобил телефон рақами мос келмаяпти",
		"Confirmloginpassword": "кириш учунг янги паролни тасдиқланг",
		"Get_codeSucc": "Тасдиқлаш коди муваффақиятли қабул қилинди",
		"New_password": "Янги пароль",
		"email_first": "Илтимос, аввал электрон почта манзилини тўлдиринг",
		"code_1minute": "Тасдиқлаш коди сизнинг мобил телефон рақамингизга юборилди, кириш 1 дақиқа давомида амал қилади.",
		"finish": "Якунлаш",
		"Retrieve_passwordPhone": "Парол мобил телефон орқали олинди",
		"bound_email": "Илтимос, боғланган электрон почта манзилини киритинг",
		"Email_verification": "Электрон почта манзилини тасдиқлаш",
		"step4": "4-қадам",
		"code_5minutes": "Тасдиқлаш коди сизнинг электрон почтангизга юборилди, ёзув 5 дақиқа давомида амал қилади.",
		"Getting_progress": "Давом этилмоқда, илтимос кутинг.",
		"Confirm_password": "Паролни тасдиқланг",
		"reset_Password": "Паролни қайта тиклаш",
		"enter_name": "фойдаланувчининг битта номини киритинг",
		"mobile_first": "Илтимос, аввал мобил телефон рақамини тўлдиринг",
		"Phone_verification": "Телефонни текшириш",
		"Reset_passwordSuc": "Парольни қайта тиклаш муваффақиятли ўтди!",
		"step2": "2-қадам",
		"step3": "3-қадам",
		"signup": "Рўйхатдан ўтиш",
		"step1": "1-қадам",
		"confirm": "Тасдиқлаш",
		"account_password": "Паролни тиклаш учун зарур бўлган ҳисоб ёзувини киритинг",
		"Change_one": "Биринчини ўзгартириш",
		"Obtain_code": "Кодни олиш",
		"Incorrect_code": "Тасдиқлаш коди нотўғри",
		"new_password": "Янги пароль",
		"passwordEmail1": "Почта қутисининг мос келмаслиги",
		"passwordEmail": "Боғланмаган почта қутиси",
		"Newloginpassword": "Янги пароль",
		"phone_number": "Телефон рақами",
		"Verify_identidy": "Шахсни тасдиқлаш",
		"Enter_account": "Ҳисоб ёзувингизга киринг",
		"Con_password": "Паролни тасдиқланг",
		"username": "Фойдаланувчи номи"
	},
	"header": {
		"log_out": "Чиқиш",
		"change_password": "Паролни ўзгартириш",
		"plant_owner": "Станция эгаси",
		"operating_manual": "Қўлланма",
		"bind_email": "Электрон почтага бириктириш",
		"bind_mobile": "Мобил қурилмани бириктириш",
		"skin": "Скинни алмаштириш",
		"shopping_mall": "Торговый центр",
		"pnAndAlias": "PN / номи",
		"pnAndSN": "PN / SN",
		"personal_infor": "Параметр",
		"pleaseSelect": "Танлаш",
		"language": "Тил",
		"pleaseSelect1": "Вақтни танланг"
	},
	"basic": {
		"backTo": "Орқага қайтиш",
		"Change_email": "Е-mail ни ўзгартириш",
		"Email": "Электрон почта манзили:",
		"uploadAvatar": "Аватарни ўзгартириш",
		"editNickname": "Тахаллуни ўзгартириш",
		"bindPhone": "Телефонни боғлаш",
		"bindPhoneTip": "Мобил телефонингизни тизимга кириш ва паролни олиш, шунингдек тизим томонидан юборилган хабарномаларни олиш учун созланг.",
		"changePwdSuc": "Парольни қайта тиклаш муваффақиятли ўтди!",
		"accountSecurity": "Хавфсиз ҳисоб ёзув",
		"modifySuc": "Муваффақиятли ўзгартирилди",
		"Personal_info": "Шахсий маълумот",
		"bindPhoneTipAfter": ", сиз тизимга киришингиз, паролингизни тиклашингиз ва тизим томонидан юборилган хабарларни олишингиз мумкин.",
		"Nickname": "Тахаллус:",
		"bindEmailTipBefore": "Боғланган электрон почта",
		"email_code": "Тасдиқлаш коди электрон почтангизга юборилди, илтимос, уни текширинг",
		"unbinding_Em": "Ечилгандан сўнг, паролингизни тиклаш учун электрон почтадан фойдалана олмайсиз!",
		"Bind_phone": "Мобил қурилмани бириктириш",
		"After_bindingPh": "Паролни боғланган телефон орқали тиклаш мумкин",
		"code_frequently": "Тасдиқлаш кодлари жуда тез-тез талаб қилинмоқда, кейинроқ қайта уриниб кўринг.",
		"finished": "Якунлаш",
		"Ple_Nickname": "Илтимос, тахаллуни киритинг",
		"bindRes": "Натижани боғланг",
		"changeBtn": "Таҳрирлаш",
		"setMobile": "Мобил телефон рақамини боғлаш",
		"Ple_email": "Илтимос, боғлаш учун электрон почта манзилини киритинг",
		"unbind_Ph": "Телефон рақамингизни боғланишдан ечиб олмоқчисиз?",
		"Bind_email": "Электрон почтага бириктириш",
		"re_enter": "Қайта қабул қилиш",
		"Obtain_code": "Кодни олиш",
		"Change_phone": "Телефон рақамини ўзгартириш",
		"noHanzi": "Парол хитойчани ўз ичига олмайди",
		"setNickname": "Тахаллуни ўрнатиш",
		"suc_em": "Электрон почта муваффақиятли боғланди",
		"Save": "Сақлаш",
		"basic": "Параметр",
		"bindEmail": "Электрон почтани боғлаш",
		"mobile_code": "Тасдиқлаш коди мобил телефонингизга юборилди, илтимос, уни текширинг",
		"code": "Код:",
		"setEmail1": "Электрон почтага бириктириш",
		"unbind_Em": "Электрон почтани боғлашни бекор қилмоқчимисиз?",
		"Untie_phone": "Телефонни ечиб олиш",
		"basicInfo": "Шахсий маълумот",
		"changePwd": "Паролни ўзгартириш",
		"unbinding_Ph": "Ечилгандан сўнг сиз паролингизни тиклаш учун телефонингиздан фойдалана олмайсиз",
		"bindPhoneTipBefore": "Боғланган телефон:",
		"Ple_phone": "Илтимос, боғланиш учун телефон рақамни киритинг",
		"Email1": "Электрон почта манзили:",
		"Email2": "Электрон почта манзили:",
		"Select_all": "Тиклаш ва ҳаммасини танлаш",
		"retry": "Қайта уриниб кўриш",
		"editMobile": "Мобил телефон рақамини ўзгартириш",
		"Ple_code": "Илтимос, текшириш кодини киритинг",
		"editEmail": "Электрон почтани ўзгартириш",
		"User_name1": "Фойдаланувчи номи",
		"personalCenter": "Ҳисоб ёзув созламалари",
		"changePwdTip": "Юқори даражадаги хавфсизликка эга парол ҳисоб ёзувни янада хавфсизроқ қилиши мумкин. Паролни мунтазам равишда ўзгартириш ва 6 дан 32 рақамгача бўлган паролни ўрнатиш тавсия этилади.",
		"suc_ph": "Tелефон рақам муваффақиятли боғланди",
		"changeRes": "Натижаларни ўзгартириш",
		"bindEmailTip": "Тизимга кириш ва паролни олиш, шунингдек тизим томонидан юборилган хабарларни олиш учун электрон почта хабарини ўрнатинг.",
		"Unbind_email": "Электрон почта орқали боғлашни бекор қилиш",
		"Mobile": "Мобил қурилма",
		"Avatar": "Фойдаланувчининг тасвири",
		"Mobile1": "Телефон рақами",
		"Nickname1": "Тахаллус",
		"User_name": "Фойдаланувчи номи:",
		"After_bindingEm": "Паролни боғланган электрон почта орқали олиш мумкин",
		"Nickname_length_tip": "Foydalanuvchi taxallusi 2 dan 32 gacha belgidan iborat bo'lishi kerak"
	},
	"strategy": {
		"cancel": "Бекор қилиш",
		"Not_upgraded": "Янгиланмаган",
		"strategy_number": "Рақам",
		"force_upgrade": "Мажбурий Янгилаш",
		"strategyIntro": "Маҳаллий янгиланиш жараёнига умумий нуқтаи",
		"message_baudrate": "Илтимос, маълумот алмашиш тезлигини танланг",
		"In_effect": "Амалда",
		"view": "Кўриш",
		"strategyUpgrade": "Стратегия Рўйхатини Янгиланг",
		"stategyStep9": "Қурилмани янгилаш ҳолати ва натижаларини кўриш",
		"message_name": "Илтимос, сиёсат номини киритинг",
		"cancel_strategy": "Сиёсатни Бекор Қилиш",
		"uprade_name": "Мажбурий Янгилаш",
		"stategyStep8": "Янгиланиш ёзувларини кўриш",
		"edit_strategy": "Сиёсатни Таҳрирлаш",
		"stategyStep7": "Янгилаш стратегияси рўйхатига янги стратегия қўшинг, янгилаш дастурини танланг, янгилаш усулини ўрнатинг ва кучга киринг, янгилаш қурилмасини боғланг ва янгилаш стратегиясини яратинг",
		"stategyStep6": "Стратегияни қўшиш",
		"message_desc": "Илтимос, сиёсат тавсифини киритинг",
		"stategyStep5": "Стратегия кучга киргандан сўнг, илова янгиланиш еслатмасини олади ва маҳаллий даражада янгиланиши мумкин",
		"suggested_upgrade": "Тавсия етилган янгиланиш",
		"stategyStep4": "Иловани маҳаллий янгилаш",
		"add_strategy": "Стратегия Рўйхатини Янгиланг",
		"stategyStep3": "Маҳаллий дастурий таъминотни бошқаришда дастурий таъминот версияси пакет файлларини юкланг",
		"stategyStep2": "Янги дастурий таъминот версияси тўплами",
		"End_date": "Муддати тугаган сана",
		"Upgrade_tip": "Илтимос, сиёсат билан боғлиқ қурилмани танланг",
		"edit": "Таҳрирлаш",
		"uprade_success": "Муваффақиятли янгиланди",
		"strategy_firmware": "Дастурий Таъминотни Янгиланг",
		"upgrade_remind": "Еслатмани Янгиланг",
		"message_timezone": "Илтимос, вақт зонасини танланг",
		"message_type": "Илтимос, прошивка турини танланг",
		"go_back": "Орқага қайтиш",
		"Upgrade_result": "Муваффақиятли қўшилди",
		"uprade_time": "Янгилаш вақти",
		"message_uprade_type": "Илтимос, янгиланиш турини танланг",
		"stategyDetail7": "Ҳолати",
		"message_firmware": "Илтимос, дастурий таъминотни танланг",
		"start_time": "Бошланиш вақти",
		"stategyDetail6": "Янгиланиш жараёни",
		"stategyDetail5": "Усул",
		"uprade_status": "Янгиланиш ҳолати",
		"stategyDetail4": "Бод даражаси",
		"TOP": "Олдинги қадам",
		"completion_strategy": "Тугатиш Стратегияси",
		"delete_firmware": "Ушбу сиёсатни бекор қилмоқчимисиз?",
		"stategyDetail9": "Тугаш вақти",
		"Next": "Кейинги қадам",
		"stategyDetail8": "Бошланиш вақти",
		"strategy_desc": "Тавсиф",
		"strategy_detail": "Стратегия Тафсилотлари",
		"strategy_status": "Ҳолати",
		"Yes_started": "Янгиланган",
		"strategy_baudrate": "Бод даражаси",
		"UpgFirmware": "Маҳаллий дастурий таъминотни бошқариш",
		"delete_desc": "Бекор қилингандан сўнг, уни тиклаш мумкин бўлмайди ва танланган янгиланиш стратегияси қурилмани янгилаш учун хабардор қила олмайди",
		"strategy_name": "Номи",
		"remind_desc": "Еслатма Тавсифи",
		"strategy_search": "Сиёсат Коди / Сиёсат Номи",
		"uprade_type": "Усул",
		"uprade_result": "Натижа",
		"associated_device": "Боғланган қурилмалар",
		"stategyDetail3": "Микродастур Тури",
		"stategyDetail2": "Прошивка ҳажми (КБ)",
		"stategyDetail1": "Дастурий Таъминотни Янгиланг",
		"upgradeList": "Ёзувлар Рўйхатини Янгиланг",
		"message_time": "Илтимос, яроқли вақтни танланг",
		"expired": "Муддати",
		"strategyIntro1": "Тавсиф: ушбу функция moduli Bluetooth маҳаллий прошивка ошириш учун фақат. Агар сиз Фи ёки 4Г каби қурилмаларнинг дастурий таъминотини янгиламоқчи бўлсангиз, илтимос [Device Management Device Лист Upgrade Operation]",
		"uprade_name1": "Тавсия етилган янгиланиш",
		"view_strategy": "Сиёсатларни Кўриш",
		"strategy_code": "Код",
		"upgrade_strategy_list": "Стратегия Рўйхатини Янгиланг",
		"start_date": "Самарали сана",
		"default_desc1": "Ушбу қурилмани ишлатишдан олдин уни юқори версияга янгилаш керак. Янгилаш учун ъ мажбурий янгилаш ъ тугмасини босинг. Илтимос, Bluetooth уланишини узманг ва янгиланиш пайтида тармоқнинг узлуксиз ишлашини таъминланг.",
		"strategyInfor": "Сиёсат Маълумотларини Янгиланг",
		"policy_information": "Сиёсат ҳақида маълумот",
		"end_time": "Тугаш вақти",
		"strategy_type": "Микродастур Тури",
		"strategy_upgrade_search": "Қурилма СН / Даталоггер ПН",
		"confirm": "Тасдиқлаш",
		"strategy_time": "Самарали вақт",
		"Not_started": "Бошланмади",
		"uprade_fail": "Муваффақияциз",
		"stategyDetail": "Номи",
		"default_desc": "Андоза Тавсиф",
		"to": "Орқага қайтиш",
		"limits":     "Maslahat: faylda A ustunida data to‘plagich PN bo‘lishi kerak, sarlavha talab qilinmaydi, quyidagi rasmda ko‘rsatilganidek.",
		"mueas":      "Yangilash strategiyasi",
		"upNum":      "Yangilanadigan qurilmalar soni",
		"deletCL":    "Strategiyani o‘chirish",
		"deletCL_TEST":"Ushbu strategiyani o‘chirmoqchimisiz?",
		"ONE_UP":     "Bitta qurilma yangilash",
		"MO_UP":      "Ommaviy qurilma yangilash",
		"MO_text": "Muvaffaqiyatli import qilindi",
        "MO_tex1": "Takrorlangan",
        "MO_tex3": "Topilmadi",
        "MO_tex2": "Tashkilot",
		"MO_tex4": "Bu proshivka faol strategiyada ishlatilmoqda, oʻchirib boʻlmaydi",
	},
	"retrieveUser": {
		"accountInfo": "Аккаунт Маълумотлари",
		"pleasePn": "Қурилманинг ПН-ни киритинг",
		"forgetUser": "Аккаунтимни унутдим",
		"phone": "Аккаунтингизга боғланган телефон рақами",
		"Return_to_login": "Паролни киритишга қайтинг",
		"illustrate": "Агар сиз у́з аккаунтингизни унитиб қу́йган бу́лсангиз, ушбу аккаунт билан ишлаган исталган қурилманинг ПН ра қамини киритиш орқали у́з аккаунтингизни эсга олишда йордам берадиган ишоралар олишингиз мумкин. Бу эса у́з навбатда у́з аккаунтингизни қайта тиклашга йордам беради.",
		"pnError": "Киритилган ПН нотўғри",
		"comfig": "Тасдиқлаш",
		"pnErrorMsg": "Маълумотлар топилмади",
		"user": "Сизнинг исмингиз",
		"email": "Аккаунтингизга боғланган електрон почта",
		"pn": "аккаунтингиз билан юритиладиган исталган қурилманинг PN рақамини киритинг"
	},
	"device": {
		"cancel": "Бекор қилиш",
		"year": "Жорий йилда электр энергия",
		"deleteSuc": "Муваффақиятли олиб ташланди!",
		"pageSize": "Саҳифа ҳажми",
		"noDataPlease": "Шахснинг ваколатлари",
		"Battery_voltage": "Батарея кучланиши",
		"select_file": "Илтимос, дастурий таъминотни танланг",
		"confirm_deldte": "Олиб ташлаш тасдиқлансинми?",
		"brandDevice": "Қурилма",
		"familyLoad": "Уй юкламаси",
		"solar": "Қуёш энергияси",
		"clear_data": "Маълумотларни тозалаш",
		"universal_firmware": "Универсал прошивка",
		"select_brate": "Илтимос, маълумот алмашиш тезлигини танланг",
		"Send_Command": "Буйруқ юбориш",
		"showParam": "Параметрларни кўрсатиш",
		"gridPower": "Тармоқ қуввати",
		"brand3": "Энергия йиғиш блоки",
		"upgrade": "Оммавий янгиланиш",
		"brand2": "Инвертор",
		"In_Upgrading": "Қурилма ёки маълумотлар регистратори янгиланишда",
		"edit": "Таҳрирлаш",
		"brand1": "Автоном инвертор",
		"brand0": "Энергия сақлаш қурилмаси",
		"analysis": "Параметрлар таҳлили",
		"Cumulative_income": "Общая прибыль от производства электроэнергии",
		"sellProfit_Today": "Поступления от продажи электроэнергии в этот день ",
		"sellProfit_Total": "Общий доход от продажи электроэнергии",
		"buyProfit_Today": "Покупка электроэнергии в тот же день ",
		"buyProfit_Total": "Общие расходы на электроэнергию",
		"pvPower": "Электроэнергия ишлаб чиқариши",
		"cur_thismonth": "Бу ой учун",
		"modify_alias": "Қурилмани ўзгартириш",
		"Device_sn": "Қурилманинг серия рақами",
		"device_code": "Протокол",
		"alternator": "Генератор",
		"detail": "Детали",
		"charged": "Заряд энергияси",
		"device": "Қурилма",
		"cur_day": "Кун",
		"datalogger_pn": "Маълумот регистраторнинг рақами",
		"Equipment_agreement": "Ускуналар учун келишув",
		"loadPower": "Юкланиш кучи",
		"standby": "Кутиш режими",
		"timeSlot": "Вақт оралиғи",
		"select_type": "Илтимос, прошивка турини танланг",
		"alarmInfo": "Хавотир сигнал ҳақида маълумот",
		"battery": "Батарея",
		"Successfully_modified": "Муваффақиятли ўзгартирилди",
		"offline": "Тармоқда эмас",
		"default": "Умолчание холати бўйича",
		"copy_val_no": "Нусха олишда хатолик",
		"Upgrading": "Янгиланиш, кутинг",
		"copy_val_yes": "Муваффақиятли нусхалаш",
		"Send_fail": "Буйруқни юборишда хатолик",
		"control_firmware_bms": "BMS прошивкаси",
		"person_authority": "Администраторнинг ҳуқуқлари",
		"distribute": "Юбориш",
		"optionTitle": "Выбран ",
		"optionTitle1": "Пункт ",
		"optionTitle2": "Выбор параметров устройства не должен превышать 4. ",
		"optionTitle4": "Выбор параметров устройства не должен превышать 12. ",
		"optionTitle3": "Пожалуйста, не выбирайте более двух вариантов.",
		"clause": "Маълумотлар детализацияси",
		"debug_suc": "Муваффақиятли откладлаш",
		"set": "Ўрнатиш",
		"refresh": "Янгилаш",
		"inverter": "Инвертор",
		"clear_val": "Маълумотларни тозалаш",
		"protocolStatistic": "Протокол статистикаси",
		"dataloggerList": "Маълумот регистраторлар рўйхати",
		"confirm": "Тасдиқлаш",
		"queryUpgrade": "Оммавий сўровни янгилаш жараёни",
		"device_cloudsUpgrade": "Прошивка:",
		"Debugfail": "Откладкада хатолик, ускуна ўчирилган.",
		"chart": "Маълумотлар диаграммаси",
		"Sn_deviceName": "SN / Ускуна номи / PN / Фойдаланувчи",
		"current_val": "Жорий қиймат",
		"upFailDevice": "Қурилмани янгилаш муваффақиятсиз ўтди",
		"copy_val": "Нусха олиш",
		"User_belong": "Фойдаланувчи",
		"deviceName": "Қурилма номи",
		"frequency": "Частотаси",
		"cloudUpgrade": "Булутли янгиланиш",
		"Device_pn": "Маълумотлар журналининг рақами:",
		"generated": "Яратилган энергия",
		"deviceList": "Қурилма",
		"warning": "Огоҳлантириш",
		"device_address": "Қурилма манзили",
		"energyFlow": "Энергия самарадорлиги",
		"upgrade_brate": "Маълумот узатиш тезлиги:",
		"batteryPower": "Батарея заряди",
		"firmware_type": "Прошивка тури:",
		"add": "Қўшиш",
		"dataTips": "Жорий қурилма автоном режимда бўлиб ва реал вақтда маълумотларга эга эмас.",
		"upDevice": "Қурилмани янгилаш",
		"statistic": "Статистика",
		"loadMore": "Кўпроқ юклаб олиш ...",
		"firmware_package_message": "Илтимос, дастурий таъминотни танланг",
		"Please_parameter": "Илтимос, параметрини танланг",
		"Allthemachines": "Барча қурилмалар",
		"deviceNo": "Сиз ҳали қурилма қўшмадингиз",
		"firmware_step_message": "Илтимос, дастлабки қадамни киритинг",
		"pro": "Лойиҳа",
		"deviceInfo": "Қурилма ҳақида маълумот",
		"moveSuc": "Муваффақиятли кўчирилди",
		"month": "Жорий ой учун электр энергия",
		"return_content": "Таркибни қайтариш:",
		"pleaseDate": "Илтимос, санани танланг",
		"ownerShip": "Egasi almashtirish",
    "oldOwner": "Avvalgi egasi:",
    "nweOwner": "Yangi egasi:",
    "loading": "Yuklanmoqda...",
    "moreLoading": "Ko'proq yuklash uchun aylantiring",
		"baudrate_message": "Илтимос, маълумот алмашиш тезлигини танланг",
		"unfollow": "Обунани бекор қилиш",
		"upgradeProgress": "Joriy yangilanish jarayoni",
		"file_fist": "Аввал прошивкани танланг",
		"device_model": "Қурилма модели",
		"followList": "Ускунага эътибор қаратинг",
		"continueUpgrade": "Янгилашни давом еттириш",
		"device_name": "Қурилма номи",
		"Magnification": "Ошириш",
		"Today_income": "Доходы от производства электроэнергии в тот же день",
		"addUpgradeSuccess": "Муваффақиятли қўшилди",
		"numberRlues": "Илтимос, тўғри қадамлар сонини киритинг",
		"normal": "Меъёрда",
		"sold": "Сотилган энергия",
		"overview": "Статистикага назар",
		"coll_alias": "Маълумот регистраторнинг номи",
		"device_upgradeStatus": "Янгиланиш ҳолати",
		"relay": "Реле",
		"consumption": "Юклаш",
		"Check_all": "Ҳаммасини бекор қилиш",
		"cur_month": "Ой",
		"noAuth": "Фойдаланувчи йўқ, кўриш учун рухсат йўқ",
		"step": "Бошланғич қадамлар",
		"edit_control": "Қурилмани бошқариш рухсатларини ўзгартириш",
		"noDate": "Келажакдаги санани танлаш мумкин емас",
		"device_upgrade": "Қурилма прошивкасини янгилаш",
		"chosenParam": "Танланган параметр",
		"updatefail": "Янгилаш хатоси, қурилма тармоқда эмас.",
		"device_pn": "PN",
		"administrator_cansee": "Танланган рухсатлар бўйсунувчи администраторга кўринади, делегатга эса кўринмайди.",
		"Instruction": "Кўрсатма:",
		"device_upgradeTime": "Янгилаш вақти",
		"Send_suc": "Буйруқни муваффақиятли юбориш",
		"Cancel_all": "Ҳаммасини бекор қилиш",
		"discharged": "Чиқариш энергияси",
		"communication_firmware": "Коммуникацион прошивка",
		"cur_today": "Бугун",
		"deviceDebug": "Ускунани ишга тушириш",
		"generation": "PV",
		"Datalogger_belong": "Маълумотлар регистратори",
		"field": "Дала назорати",
		"defaultUpgrade": "Стандарт буйича янгилаш",
		"reset": "Қайта юклаш",
		"person_cansee": "Танланган рухсатлар эгасига кўринади, делегатга эса кўринмайди.",
		"device_alias": "Қурилма номи:",
		"minSelect": "Камида 1 параметрни текшириш керак.",
		"deviceUpgradeProgress": "Yangilanish jarayoni",
		"maxSelect": "Фақат 7 параметр максимал текширилиши мумкин",
		"Output_table": "Чиқиш жадвали",
		"Upload": "Юклаб олиш",
		"Input_form": "Кириш жадвали",
		"upgrade1": "Янгилаш",
		"more": "Більше дій",
		"one_click_read": "Прочитати за один клік",
		"device_code_form": "Протокол:",
		"power": "Қуввати",
		"device_sn": "Қурилманинг серия рақами",
		"bought": "Сотиб олинган энергия",
		"cur_thisyear": "Бу йилда",
		"upSuccessDevice": "Қурилма муваффақиятли янгиланди",
		"proList": "Лойиҳалар рўйхати",
		"serial_number": "Қурилманинг серия рақами:",
		"grid": "Тармоқ",
		"control_firmware_slavmcu": "Slav MCU прошивкаси",
		"report": "Ҳисобот",
		"upgradeType": "Янгилаш усули",
		"device_upgrade1": "Охирги янгиланиш ёзуви",
		"uploadSuccess": "Юклаб олиш муваффақиятли ўтди",
		"Current_data": "Жорий маълумотлар",
		"Upload1": "Янги прошивкани юклаш",
		"Send_Input": "Юбориш учун операция қийматини киритинг",
		"device_type": "Қурилма тури",
		"selecParameters": "Танланган параметр",
		"used": "Фойдалланган энергия",
		"System_Failed": "Тизим алоқа аномалиялари ёки бошқа сабабларга кўра қурилмани янгилаш жараёнини бошлай олмади.",
		"Unit": "Бирлик",
		"modifySuc": "Муваффақиятли ўзгартирилди",
		"cur_year": "Йил",
		"firmware_type_message": "Илтимос, турини танланг",
		"such_as": "Буйруқни киритинг, масалан: AA BB CC DD EE FF",
		"day": "Реал вақтдаги қуввати",
		"obtain": "Қабул қилиш",
		"all": "Жами электр энергия",
		"device_status": "Қурилманинг ҳолати",
		"read": "Ҳисоблаш",
		"deleteDevice": "Қурилмани ўчириш",
		"update_suc": "Муваффақиятли янгиланди",
		"admin_authority": "Маълумотлар йўқ, бошқа вақтни танланг",
		"continueUpgradeSuccess": "Муваффақиятли янгиланди ва қўшилди",
		"send": "Юбориш",
		"control_firmware1": "Бошқариш прошивкаси 1",
		"datalogger": "Қурилмалар рўйхати",
		"control_firmware2": "Бошқариш прошивкаси 2",
		"device_upgradeProgress": "Янгиланиш жараёни",
		"Operation": "Ишлаш",
		"delete": "Олиб ташлаш",
		"addUpgrade": "Yangilash vazifasini qo'shing",
		"Device_Offline": "Қурилма ёки маълумотлар регистратори ўчирилган",
		"Field_Name": "Майдон номи",
		"device_upgradeFirmware": "Қурилмани янгилаш учун прошивка пакетини танланг",
		"Voltage": "Кучланиш",
		"Update_Completed": "янгиланиш тугалланди",
		"parameter": "Параметр",
		"device_continueUpgrade": "Ускуналар янгиланишда давом етмоқда",
		"moveResults": "Натижаларни кўчириш",
		"value": "Қиймати",
		"chooseProtocol": "Протоколни танланг:",
		"optionalParam": "Қўшимча параметр",
		"fileExceed": "Файл ҳажми жуда катта",
		"debug": "Откладкаси",
		"Electric": "Электрлик",
		"fault": "Хатолик",
		"control": "Назорат",
		"select_firmware": "Илтимос, прошивка файлини танланг",
		"follow": "Обуна бўлиш",
		"upBatchDeviceTip": "Эслатма. Тўпламли янгиланиш бир нечта қурилмалар учун бир хил қурилманинг дастурий таъминотини янгилаш учун мўлжалланган. Агар қурилмангизга қайси прошивка мос келишини билмасангиз, диққат билан танланг!",
		"cloudsUpgrade": "Булутли янгиланиш",
		"device_upgradeName": "Янгиланиш прошивкасининг номи",
		"instruction_response": "Кўрсатмаларни юбориш, жавобни кутиш...",
		"error1": "Сиз фақат форматдаги файлларни юклашингиз мумкин .bin и .hex!",
		"dataview": "Ҳақиқий вақт параметрлари"
	},
	"account": {
		"cancel": "Бекор қилиш",
		"Delete": "Олиб ташлаш",
		"enterHome": "Қайтариш",
		"reason1": "Ускуна бўйича маълумотлар йўқ",
		"reason": "График кўрсатилмаётганлигининг сабаби қуйидагилар бўлиши мумкин:",
		"role1": "Фойдаланувчи тури:",
		"reason2": "Ускуналар шартномасида, электр энергияси ишлаб чиқариш, энергия истеъмоли, сотиб олинадиган қувват, сотиладиган қувват, қувватлаш ва тушириш қуввати параметрлари майдонлари мавжуд эмас.",
		"projects": "Лойиҳалар",
		"reason3": "Ускуналар протоколида энергия ишлаб чиқариш, юклаш қуввати, батарея қуввати ва тармоқ қуввати параметрлари йўқ.",
		"resetPwdSuc": "Парольни қайта тиклаш муваффақиятли ўтди!",
		"newPwd": "Янги пароль",
		"deleteSuc": "Муваффақиятли олиб ташланди!",
		"binding": "Боғлаш",
		"Edit": "Таҳрирлаш",
		"groupsuccess": "Гуруҳ муваффақиятли тарзда катталашди!",
		"createSuc": "Ҳисоб қайди мувафақиятли тарзда яратилди!",
		"generalAccount": "Асосий ҳисоб қайди",
		"Individual_allocation": "Индивидуал тақсимлаш",
		"password": "Парол",
		"enablesuccess": "Муваффақиятли ёқилди!",
		"enable": "Ёқиш",
		"searchPro": "Лойиҳани қидириш",
		"accountManage": "Ҳисоб қайди",
		"relatedOwner": "Бириктирилган эга",
		"confirmpassword": "Паролни тасдиқланг",
		"nickname1": "Тахаллус:",
		"Assigned_successfully": "Муваффақиятли тайинланган",
		"Confirm_assignment": "Мақсадни тасдиқлаш",
		"selectUserType": "Илтимос, фойдаланувчи гуруҳини танланг!",
		"PNNum": "PN",
		"devices": "Қурилмалар",
		"deletegroup": "Ушбу гуруҳдан чиқиш",
		"adminRelated": "Илтимос, маъмурни танланг",
		"createAccount": "Яратиш",
		"operate": "Ишлаш",
		"groupManage": "Гуруҳни бошқариш",
		"Distribution_method": "Тарқатиш усули",
		"IsIt": "бу",
		"userAccount": "Фойдаланувчи",
		"deleteUser": "Фойдаланувчини олиб ташлаш",
		"projectNum": "Қурилмалар сони",
		"deletegroupsuccess": "Гуруҳ муваффақиятли тарк этилди!",
		"afterEnable": "Ёқилгандан сўнг, ҳисоб қайди тизимга кириш, ҳисоб қайдининг тегишли таркибини кўриш ёки ўзгартириш учун қайта тикланиши мумкин.",
		"changeGroupSuc": "Гуруҳни мувафақиятли ўзгартириш!",
		"role": "Фойдаланувчи тури",
		"disablesuccess": "Муваффақиятли ўчирилди!",
		"groupto": ".... да гуруҳлаш",
		"Distribution_collector": "Distribution collector",
		"confirmDisable": "Бу фойдаланувчининг узилиши тасдиқлансинми?",
		"accountStatus": "Ҳисоб қайдининг мақоми",
		"groupAccount": "Гуруҳ",
		"defaultGroup": "Сукут бўйича гуруҳ",
		"nickname": "Тахаллус",
		"password1": "Парол:",
		"email": "Электрон почта манзили",
		"order_check": "Текшириш",
		"relatedSuccess": "Бирлаштириш муваффақиятли бўлди",
		"Deletesuccessfully": "Ҳисоб қайди муваффақиятли олиб ташланди!",
		"powerStationOwner": "Станция эгаси",
		"err_orderNum": "Ҳаммаси жойида",
		"tooltipContent": "Администратор буюртма бўйича барча маълумотлар йиғиндисини буюртма рақами орқали бўйсунувчи дилерга тайинлаши мумкин",
		"distributor": "Дистрибъютор",
		"Allocation_result": "Тақсимлаш натижаси",
		"confirm": "Тасдиқлаш",
		"ownedDevices": "Ўз қурилмалари",
		"resetPwd": "Паролни қайта тиклаш",
		"activeStatus": "Фаол мақом",
		"createTime": "Яратилган вақт",
		"placeholder1": "Битта фойдаланувчининг номини киритинг/мобил телефон рақами",
		"disable": "Ўчириш",
		"accounts": "Ҳисоблар",
		"lastLogin": "Охирги кириш",
		"allGroup": "Барча гуруҳлар",
		"confirmpassword1": "Паролни тасдиқланг:",
		"editUser": "Фойдаланувчини ўзгартириш",
		"cannotRedirect": "Бу ҳисоб қайди энергия сақлаш ҳисоб қайди эмас, қайта йўналтириш мумкин эмас!",
		"modifiedsuccess": "Фойдаланувчи ҳақидаги маълумотлар муваффақиятли ўзгартирилди!",
		"email1": "Электрон почта манзили:",
		"manageAccount": "Бошқарув ҳисоб қайди",
		"Order_allocation": "Буюртмани тақсимлаш",
		"finish": "Якунлаш",
		"group": "Гуруҳ",
		"changeGroup": "Гуруҳлашни қуйидагича ўзгартириш:",
		"limitFormat": "Файлларни фақат xlsx ва xls форматларида юклаш мумкин",
		"ascription": "Тегишлилик",
		"ascriptionSuccess": "Atribut muvaffaqiyati",
		"ascription_result": "atribut natijalari",
		"newPwd1": "Янги пароль:",
		"group1": "Гуруҳ:",
		"disableSuc": "Ҳисоб қайди муваффақиятли ўчирилди!",
		"currentTotal": "Жорий",
		"uselists": "Фойдаланувчиларни бошқариш рўйхати",
		"powerStationViewer": "Электр станцияси кузатувчиси",
		"afterDisable": "Ўчирилгандан сўнг, ҳисоб қайди тизимга кира олмайди, тегишли ҳисоб қайди таркибини эса, кўриш ёки ўзгартириш мумкин бўлмайди.",
		"unclassified": "Таснифланмаган",
		"submit": "Кўриб чиқиш учун тақдим этиш",
		"newPwdEmpty": "Янги пароль бўш бўлиши мумкин эмас, илтимос, уни тўлдиринг!",
		"accountName": "Фойдаланувчи номи",
		"pwdresetsuccess": "Пароль муваффақиятли қайта тикланди!",
		"order_number": "Буюртма рақами",
		"mobile1": "Мобил қурилма:",
		"admin": "Маъмур",
		"riyueyuan_lineSonAdmin": "Ishlab chiqarish liniyasining sub-menejeri",
		"riyueyuan_SonAdmin": "subadministrato",
		"plantOwner": "Станция эгаси",
		"accountName1": "Фойдаланувчи номи",
		"accountName2": "фойдаланувчининг битта номини киритинг",
		"Batch_allocation": "Оммавий тақсимлаш",
		"deviceNum": "Қурилма",
		"chooseGroup": "Илтимос, гуруҳни танланг",
		"editAccount": "Ҳисоб қайдини таҳрирлаш",
		"notRecovered": "Олиб ташлангандан сўнг, тиклаш мумкин эмас ...",
		"placeholder": "Фойдаланувчи Номини қидириш / мобил телефон рақамини",
		"accountRole": "Роль",
		"Ple_orderNum3": "коллекторлар, ажратишни тасдиқланг",
		"Ple_orderNum2": "Бу буюртмада бор",
		"Ple_orderNum": "Илтимос, буюртма рақамини киритинг",
		"Ple_orderNum1": "Илтимос, буюртма рақамини тўғри киритинг",
		"lastLoginTs": "Охирги кириш вақти",
		"mobile": "Телефон",
		"accountGroup": "Фойдаланувчилар гуруҳи",
		"nodata": "Маълумотлар йўқ",
		"allTypeUser": "Барча турдаги фойдаланувчилар",
		"confirmDelete": "Олиб ташлаш тасдиқлансинми?",
		"confirmEnable": "Бу фойдаланувчининг ёқилиши тасдиқлансинми?",
		"dataloggerNum": "Маълумотни қайд этувчилар",
		"allAccount": "Барча фойдаланувчилар",
		"err_orderNum1": "Маълумот регистраторлари уланган. Илтимос, буюртмада регистраторлар алоқаси йўқлигини тасдиқланг",
		"accountList": "Ҳисоб қайдлари рўйхати",
		"dataogger_swith": "Ma'lumotlarni sotib oluvchini qo'shing",
		"dataogger_swithTip": "Hisobda ma'lumotlarni qo'shish huquqiga ega bo'lishi mumkinmi?",
		"account_number": "Hiso",
		"Role_authority": "Ruxsatla",
		"authority_Management": "Ruxsat boshqaruvi",
		"Related_roles": "Og'liq rol",
		"Ple_role1": "Iltimos, tegishli rolni tanlang",
		"Ple_role2": "Rol nomi/identifikatorini kiriting",
		"Add_role": "Yangi rol qo'shing",
		"Edit_role": "Редагувати роль",
		"Role_id": "Rol identifikatori",
		"Role_name": "Belgi nomi",
		"Ple_role3": "Rol nomini kiriting",
		"Role_des": "ol tavsifi",
		"Ple_role4": "Rol tavsifini kiriting",
		"module": "Modul",
		"First_page": "Sahifa",
		"Secondary_page": "Ikkilamchi sahifa",
		"Function_points": "Funktsiya",
		"Remove_role": "Rolni o'chirish",
		"Ple_role5": "Hisob ruxsatlarini tekshiring",
		"No_permission_prompt": "Ruxsat yo'q, yuqori administrator bilan bog'laning",
		"Ple_role6": "Rol nomi allaqachon mavjud, uni qayta kiriting.",
		"limit_UserTypeNum": "Cheklovdan oshib ketdi, hisob turi allaqachon mavjud",
		"limit_UserTypeDataPermission": "Dealer hisoblar tanlangan ma'lumotlar huquqi bo'yicha rollarni bog'lamaydi.",
		"edit_limit_UserTypeDataPermission": "Bu rol sotuvchi hisobiga bog'langan va ma'lumotlar uchun ruxsatlar tahrirlanishi mumkin emas.",
		"dataPermission": "Ma'lumotlar huquqi",
		"functionalPermission": "Funksional huquq"
	},
	"browse": {
		"pleaseUsr": "Илтимос, суб ҳисоб қайдномасини киритинг",
		"deleteBrowse": "Олиб ташлаш",
		"pleaseDevice": "Елементни Танлаш",
		"editBrowse": "Суб Ҳисобини Таҳрирлаш",
		"addSuccess": "Суб ҳисоб муваффақиятли қўшилди",
		"password": "Парол",
		"usr": "Суб-ҳисоб",
		"pleaseDevice_title": "Илтимос, лойиҳани танланг",
		"deleteSuccess": "Муваффақиятли олиб ташланди!",
		"confirmPassword": "Паролни тасдиқланг",
		"Enable": "Ёқиш",
		"Disable": "Ўчириш",
		"email": "Электрон почта манзили",
		"accountInfo": "Аккаунт Маълумотлари",
		"delete_browse": "Агар суб ҳисобини ўчириш учун ишончингиз комилми?",
		"addBrowse": "Суб Ҳисоб Қўшиш",
		"gts": "Рўйхатдан сана",
		"mobile": "Телефон",
		"newPassword": "Янги пароль",
		"editSuccess": "Суб ҳисоб қайдномаси муваффақиятли таҳрирланди",
		"please_browsepwd": "Илтимос, янги паролни текширинг ва паролни киритиш талабларини тасдиқланг",
		"pleaseStatus": "Ҳолатни Танлаш",
		"device": "Лойиҳани Танлаш",
		"usrInfo": "фойдаланувчи ҳақида маълумот",
		"enableStatus": "Ҳолатни Ёқиш",
		"username": "Фойдаланувчи номи",
		"desc": "Десc"
	},
	"collectionFrequencyUP": {
		"collect_fast": "Energiya oqimi to'plashni tezlashtrish",
		"collect_fast2": "Energiya oqimini tezlashtirish",
		"collect_fast_fail": "Tezlashtirish amalga oshmadi, qayta urinib ko'ring",
		"collect_fasting": "Tezlashtirishda",
		"collect_fast_starting": "Tezlashtirish boshlanmoqda",
		"collect_fast1": "Batafsil ma'lumotlarni to'plashni tezlashtrish",
		"collect_fast1ing": "Data tezlashtirilmoqda",
		"paySecCon": "Оплата тасдиқланмаси",
		"energyFetchPic": "Rizvot berishni tassadiqlang? Rizvot berishning tezlashtirilgan yuzasi energiya akim grafigi sahifasining parametrlari, shunga nida",
		"historyFetchPic": "Rizvot berishni tassadiqlang? Rizvot berishning tezlashtirilgan yuzasi ma'lumotlar tafsilotlari sahifasining parametrlari, shunga nida",
		"reRechargeTip1": "Joriy qurilma uchun energiya oqimini tezlashtirish xizmati allaqachon sotib olingan. Xaridni davom ettirish yana to'lovga olib keladi. Davom etasizmi?",
		"reRechargeTip": "Joriy qurilma uchun ma'lumot tafsilotlarini tezlashtirish xizmati allaqachon sotib olingan. Xaridni davom ettirish yana to'lovga olib keladi. Davom etasizmi?",
		"continueRecharge": "To'lovni davom ettirish",
		"collect_fasting_title": "Haqiqiy vaqt parametrlari saqlanmaydi",
		"collect_Order_Record": "Tezlik turligi",
		"collect_recharge": "Ma'lumotlar to'plashni tezlashtrishni qayta yuklash (batafsil ma'lumotlar to'plashni tezlashtrish)",
		"collect_recharge1": "Ma'lumotlar to'plashni tezlashtrishni qayta yuklash (energiya oqimi to'plashni tezlashtrish)",
		"Package": "Tezlashtirish paketi",
		"every_interval": "Joriy tanlangan tezlashtirish spetsifikatsiyasi: har interval",
		"gather": "To'plash",
		"Once": "marta",
		"Payment_method": "To'lov usuli",
		"Online_payment": "Onlayn to'lov",
		"Recharge_now": "Hozir to'lov qiling",
		"have_read": "Men to'liq o'qidim",
		"Collection_terms": "To'plash tezligini tezlashtirish to'lov shartlari",
		"Purchase_Terms": "Sotib olish shartlari",
		"Purchase_Terms1": "Ma'lumot yig'ish tezlashtirish amal qilish muddati",
		"Purchase_Terms2": "Ma'lumot yig'ish tezlashtirish xizmatining tugash muddati siz sotib olgan paket muddatiga qarab avtomatik ravishda hisoblanadi. Aniq tugash muddati sahifada ko'rsatilganiga bog'liq",
		"Purchase_Terms3": "Ba'zi parametrlarni tezlashtirish uchun to'plash tezligini sozlash mumkinmi?",
		"Purchase_Terms4": "Iltimos, yangi versiyamizni kuting, hozirgi versiya faqat barcha ko'rsatilgan parametrlarni to'plashni tezlashtirishni qo'llab-quvvatlaydi, sizga noqulaylik tug'dirgan bo'lsa, uzr so'raymiz!",
		"Purchase_Terms5": "Paket narxi",
		"Purchase_Terms6": "Bizning to'lovlarimiz sizning parametrlaringiz soni, tezlashtirilgan to'plash tezligi, yuklash soni va saqlash muddati asosida hisoblanadi",
		"Purchase_Terms7": "Boshqa savollaringiz bo",
		"Purchase_Terms8": "Agar sizda boshqa savollar bo'lsa, bizning onlayn mijozlarga xizmat ko'rsatishimizga murojaat qilishingiz mumkin, biz sizga batafsil javob beramiz",
		"Collect_terms": "To'plash tezligini tezlashtirish to'lov shartlari",
		"Collect_terms1": "To'plash tezligi va tezlashtirish xizmatlari shartlari",
		"Collect_terms2": "I. Paketning qo'llanilish doirasi",
		"Collect_terms3": "Sizning to'lov qilgan to'plamingizda ishlatiladigan ko'rsatkichlar (Eslatma: Agar siz tezlashtirishni vizualizatsiya sahifasida amalga oshirsangiz, paketning qo'llanilish doirasi faqat vizualizatsiya sahifasining ko'rsatkichlari bilan cheklanadi; agar siz tarixiy ma'lumotlar sahifasida tezlashtirishni amalga oshirsangiz, paket faqat tarixiy ma'lumotlar sahifasining ko'rsatkichlari bilan cheklanadi)",
		"Collect_terms4": "II. Shartnoma/ustaxonani almashtirishni qo'llab-quvvatlamaydi",
		"Collect_terms5": "Shartnoma yoki uskunani almashtirish tezlashtirishdan foydalanish imkonini bermaydi",
		"Collect_terms6": "III. Paketni bekor qilish",
		"Collect_terms7": "To'lov qilinganidan so'ng, bekor qilish yoki o'zgartirish mumkin emas",
		"Collect_terms8": "IV. Paket narxi",
		"Collect_terms9": "Bizning to'lovlarimiz sizning parametrlaringiz soni, tezlashtirilgan to'plash tezligi, yuklash soni va saqlash muddati asosida hisoblanadi",
		"Collect_terms10": "V. Trafik sarfi",
		"Collect_terms11": "To'plash tezligini tezlashtirish trafik sarfini oshiradi",
		"Scan_payment": "QR-kod orqali to'lov",
		"Recharge_result": "To'lov natijasi",
		"Recharge_successful": "To'lov muvaffaqiyatli",
		"Recharge_successful_next": "Tabriklaymiz, sizning to'lovingiz muvaffaqiyatli amalga oshdi, endi biz sizning to'plash tezligingizni yangilaymiz, shundan so'ng siz o'zgarishlarni kuzatishingiz mumkin",
		"Order_No": "Buyurtma raqami",
		"Recharge_time": "To'lov vaqti",
		"Recharge_amount": "To'lov summasi",
		"view_order": "Buyurtmani ko'rish",
		"Recharge_failed": "To'lov muvaffaqiyatsiz",
		"Recharge_failed_next": "Kechirasiz, to'lov muvaffaqiyatsiz amalga oshdi, iltimos, qaytadan to'lovni amalga oshiring",
		"PN_order": "PN/Buyurtma raqami",
		"View_Details": "Tafsilotlarni ko'rish",
		"Type": "Qiymatlash turi",
		"Real_parameters": "Real vaqt parametrlar",
		"History_Data": "Tarixiy ma'lumotlar",
		"acquisition_frequency": "To'plash tezligi",
		"device_Info": "Uskuna ma'lumotlari",
		"noRecharg": "Kollektor qayta zaryadlashni qo'llab-quvvatlamaydi",
		"noRecharg_min": "Sizning yig'ish tezligingiz eng yuqori tezlikka erishdi!",
		"noRecharg_wifi": "Joriy versiya faqat Wi-Fi moduli ma'lumotlar yig'uvchilarni qo'llab-quvvatlaydi",
		"paypalTip": "Yakuniy to'lov miqdori PayPal-ga bo'ysunadi",
		"upPrice": "Narh farqi",
	},
	alarmNew: {
		'fileName': 'Fayl nomi',
		'fileSize': 'Fayl hajmi',
		'fileStatus': 'Fayl holati',
		'progress': 'Jarayon',
		'can': 'Yuklab olish mumkin',
		'no': 'Eksport qilinmoqda',
		'history': 'Eksport tarixi'
	},
		shuoriExport:{
       "exportRecords": "Eksport yozuvlari",
       "export": "Eksport qilish",
       "exportTask": "Eksport vazifasi yaratildi. Faylni keyinchalik \"Eksport yozuvlari\" bo'limidan yuklab oling.",
       "noDownload": "Fayl manzili noto'g'ri yoki yuklab bo'lmadi. Qaytadan urinib ko'ring.",
	   'data': 'Sana',
	},
		colUnBindRecord: {
	'UnBindRecord': "Ma'lumot yig'gichning bog'lanishini bekor qilish yozuvi",
    "unStatus": "Bog‘lamadan chiqarish holati",
    "unScene": "Bog‘lamadan chiqarish ssenariysi",
    "oldUser": "Asl foydalanuvchi",
    "newUser": "Yangi foydalanuvchi",
    "unCount": "Bog‘lamadan chiqarishlar soni",
    "pnBarCode": "PN shtrix-kodi",
    "devicePicture": "Qurilmaning haqiqiy rasmi",
    "ip": "Bog‘lanmagan IP",
    "unTime": "Bog‘lamadan chiqarish vaqti"
	},
		rosRecharge: {
		'electronicInvoicing': 'Elektron hisob-faktura',
		'issueEInvoice': 'Elektron hisob-faktura berish',
		'invoiceHistory': 'Hisob-faktura tarixi',
		'rechargeDuration': 'To‘ldirish muddati',
		'year': 'yil',
		'month': 'oy',
		'day': 'kun',
		'days': 'kun',
		'pendingPayment': 'To‘lov kutilmoqda',
		'paymentSuccess': 'To‘lov muvaffaqiyatli',
		'paymentFailed': 'To‘lov muvaffaqiyatsiz',
		'orderClosed': 'Buyurtma yopildi',
		'serviceTerminated': 'Xizmat to‘xtatildi',
		'unpaid': 'To‘lanmagan',
		'paying': 'To‘lanmoqda',
		'paid': 'To‘langan',
		'refunded': 'Qaytarilgan',
		'cancelled': 'Bekor qilingan',
		'rechargeSuccess': 'To‘ldirish muvaffaqiyatli',
		'rechargeFailed': 'To‘ldirish muvaffaqiyatsiz',
		'pleaseSelectDate': 'Iltimos, sanani tanlang',
		'orderNo': 'Buyurtma raqami',
		'batchInvoicing': 'Ommaviy hisob-faktura',
		'rechargeType': 'To‘ldirish turi',
		'trafficRecharge': 'Trafik to‘ldirish',
		'collectRecharge': 'Yig‘ish to‘ldirish',
		'rechargeStatus': 'To‘ldirish holati',
		'invoice': 'Hisob-faktura',
		'invoiceStatus': 'Hisob-faktura holati',
		'invoiceTime': 'Hisob-faktura vaqti',
		'viewDetail': 'Tafsilotlarni ko‘rish',
		'invoicing': 'Hisob-faktura berilmoqda',
		'invoiceSuccess': 'Hisob-faktura berildi',
		'invoiceFailed': 'Hisob-faktura berish muvaffaqiyatsiz',
		'issueElectronicInvoice': 'Elektron hisob-faktura berish',
		'invoiceType': 'Hisob-faktura turi',
		'generalInvoice': 'Oddiy hisob-faktura',
		'specialInvoice': 'Maxsus hisob-faktura',
		'headerType': 'Sarlavha turi',
		'companyHeader': 'Kompaniya sarlavhasi',
		'personalHeader': 'Shaxsiy/Korporativ bo‘lmagan sarlavha',
		'pleaseInputCompanyHeader': 'Kompaniya sarlavhasini kiriting',
		'taxNumber': 'Kompaniya soliq raqami',
		'pleaseInputTaxNumber': 'Soliq to‘lovchining identifikatsiya raqamini kiriting',
		'headerName': 'Sarlavha nomi',
		'suggestPersonalName': 'Shaxsiy ism/do‘kon nomini kiritish tavsiya etiladi',
		'invoiceContent': 'Hisob-faktura mazmuni',
		'internetCommService': 'Internet aloqa xizmatlari',
		'invoiceAmount': 'Hisob-faktura miqdori',
		'yuan': 'soʻm',
		'moreInfo': 'Qo‘shimcha ma‘lumot',
		'remarkAddressEtc': 'Izoh, manzil va boshqalar',
		'companyAddress': 'Kompaniya manzili',
		'pleaseInputCompanyAddress': 'Kompaniya manzilini kiriting',
		'companyPhone': 'Kompaniya telefoni',
		'pleaseInputCompanyPhone': 'Kompaniya telefonini kiriting',
		'openingBank': 'Hisob banki',
		'pleaseInputOpeningBank': 'Bank nomini kiriting',
		'bankAccount': 'Bank hisobi',
		'pleaseInputBankAccount': 'Bank hisob raqamini kiriting',
		'remark': 'Izoh',
		'pleaseInputRemark': 'Izoh kiriting',
		'email': 'Elektron pochta',
		'pleaseInputEmail': 'Elektron pochta manzilini kiriting',
		'cancel': 'Bekor qilish',
		'submit': 'Yuborish',
		'invoiceResult': 'Hisob-faktura natijasi',
		'invoiceSubmitted': 'Hisob-faktura so‘rovi yuborildi',
		'invoiceExpectedTip': 'Hisob-faktura 48 soat ichida beriladi, iltimos, pochtangizni tekshiring',
		'viewInvoiceStatus': 'Hisob-faktura holatini ko‘rish',
		'pleaseInputHeaderName': 'Sarlavha nomini kiriting',
		'pleaseInputValidEmail': 'To‘gʻri elektron pochta manzilini kiriting',
		'invoiceApplyFailed': 'Hisob-faktura so‘rovi muvaffaqiyatsiz',
		'viewInvoice': 'Hisob-fakturani ko‘rish',
		'downloadPdf': 'PDF faylni yuklab olish',
		'manualService': 'Mijozlarga xizmat',
		'invoiceSentToEmail': 'Hisob-faktura ma‘lumoti elektron pochtangizga yuborildi, iltimos, tekshiring',
		'pleaseWaitInvoicing': 'Iltimos, hisob-faktura berish tugashini kuting',
		'pleaseContactManual': 'Iltimos, hisob-faktura uchun xizmat ko‘rsatish bilan bog‘laning',
		'noPdfAvailable': 'Yuklab olish uchun PDF fayl yo‘q',
		'serviceUnavailable': 'Mijozlarga xizmat ko‘rsatish funksiyasi hozircha mavjud emas',

	}
}
export default uz;
